import { Telegram } from "@material-ui/icons";
import { de } from "date-fns/locale";

export const diccionario_cat = {
  hola: "Hola",
  Leida: "Llegida",
  Archivada: "Arxivada",
  empleados: "Empleats",
  BloquearReserva: "Bloquejar Reserva",
  empleado: "Empleat",
  empezar: "començar",
  empezada: "començada",
  organizacion: "Organització",
  estructura: "Estructura",
  organizativa: "organitzativa",
  crear: "Crear",
  visualizar: "Visualitzar",
  modificar: "Modificar",
  listados: "Llistats",
  listado: "Llistat",
  recursos: "Recursos Humans",
  resumen: "Resum",
  evaluados: "Avaluats",
  evaluado: "Avaluat",
  evaluaciones: "Avaluacions",
  evaluacion: "Avaluació",
  evaluada: "Avaluada",
  pruebas: "Proves",
  areas: "Àrees",
  evainiciadas: "Ava. iniciades",
  abstencion: "Abstenció",
  evarealizadas: "Ava. realitzades",
  ranking: "Rànquing empleats per avaluació",
  nombre: "Nom",
  Nombre: "Nom",
  apellidos: "Cognoms",
  area: "Àrea",
  estado: "Estat",
  fecha: "Data",
  resultado: "Resultat",
  todas: "Totes",
  año: "any",
  competencias: "competències",
  destacadas: "destacades",
  buenas: "bones",
  normales: "normals",
  alejadas: "allunyades",
  submitida: "submesa",
  submitidas: "submeses",
  submitir: "submetre",
  completas: "completes",
  periodos: "Períodes",
  fomulario: "Formulari",
  actualizar: "Actualitzar",
  busqueda: "Camps de cerca",
  rellenar: "Omple un camp amb el valor de l'empleat que vols recuperar",
  rellenar2: "Omple un camp amb el valor de l'estructura que vols recuperar",
  limpiarcampos: "Netejar camps",
  seleccionado: "seleccionat",
  hombre: "Home",
  mujer: "Dona",
  otros: "Altres",
  genero: "Gènere",
  cargo: "Càrrec",
  acceso: "Accés",
  herramienta: "eina",
  registro: "registre",
  telefono: "Telèfon",
  inicio: "inici",
  Bueno: "Bé",
  Destacado: "Destacat",
  Alejado: "Allunyat",
  Normal: "Normal",
  sin: "Sense",
  finalizar: "finalitzar",
  aviso0: "Has de respondre almenys alguna pregunta del qüestionari per començar l'avaluació",
  aviso1: "Per poder finalitzar l'avaluació heu de respondre totes les qüestions",
  aviso2: "Per submetre l'avaluació heu d'activar el botó 'Submetre'",
  aviso3: "AVALUACIÓ SOMESA, qualsevol modificació posa't en contacte amb l'administrador",
  gerente: "Gerent",
  observaciones: "Observacions",
  aviso4: "Voleu reobrir l'avaluació?",
  aviso5: "Vols submetre l'avaluació? Un cop submesa ja no la podràs modificar",
  deLaOrganizacion: "DE L'ORGANITZACIÓ (CORE)",
  PERSONALES: "PERSONALS",
  delPuesto: "DEL LLOC",
  funcionales: "(FUNCIONALS)",
  INTERPERSONALES: "INTERPERSONALS",
  delPuestoFuncionales: "DEL LLOC (FUNCIONALS)",
  Email: "Email",
  Fecha_Creacion: "D. alta",
  Id: "Identificador",
  SOSBloqueo: "SOS",
  Codigo_seguridad: "Codi de seguretat (màx 5 dígits)",
  Codigo_vecino: "Codi de registre de la comunitat",
  Cp: "C.P.",
  Poblacion: "Població",
  Seguro_nombre: "Companyia d'assegurances",
  tooltip: "Companyia d'assegurances associada a la Comunitat",
  Poliza: "Pòlissa",
  IBAN: "Compte IBAN",
  Vecinos: "Veïns",
  Pago_App: "Pagament Mensual APP",
  Cif: "CIF",
  tip_comunidad: "Companyia d'assegurances associada a la Comunitat",
  listaComunidades: "Llista de comunitats",
  Direccion: "Direcció",
  Provincia: "Província",
  estadoComunidad: "Estat",
  Altac365: "Alta c365",
  AltaC3652: "Alta",
  Fecha_Baja: "D. Baixa",
  Bloqueada: "Bloquejada",
  tip_Bloqueada: "Clica per bloquejar/desbloquejar l'accés dels usuaris a l'app",
  tip_Alta: "Clica per contractar Comunitat 365",
  tip_Baja: "Clica per actualitzar contracte o donar-lo de baixa",
  tituloBloquear: "Bloquejar comunitat",
  tituloDesBloquear: "Desbloquejar comunitat",
  cuerpoBloquear: "Feu clic a acceptar per confirmar el bloqueig de la comunitat",
  cuerpoDesBloquear: "Feu clic a acceptar per confirmar el desbloqueig de la comunitat",
  tip_EnvioComunidades: "Envia avisos a les comunitats prèviament seleccionades",
  ENVIAR_AVISO: "Enviar avís",
  ENVIAR_AVISO_DOCUMENTOS: "Enviament avís documentació",
  Buscar: "Cerca",
  Buscador: "Cercador",
  Inicio: "Inici",
  Comunidades: "Comunitats",
  Incidencias: "Incidències",
  Gremios: "Proveïdors",
  Roles: "Rols",
  Notificaciones: "Notificacions",
  Despacho: "Despatx",
  Documentos: "Documents",
  Usuarios: "Usuaris",
  DescripcionMenuInicial: "Descripció Menú Inicial",
  CIF: "CIF",
  Administracion: "Administració",
  AvisoLegal: "Avís Legal",
  PoliticaPrivacidad: "Política de Privadesa",
  PoliticaCookies: "Política de Cookies",
  DescComunidades: "Gestió de comunitats",
  DescIncidencias: "Gestió d'incidències",
  DescGremios: "Gestió de proveïdors",
  DescRoles: "Gestió de rols",
  DescUsuarios: "Gestió d'usuaris",
  DescNotificaciones: "Gestió de notificacions",
  DescAdministracion: "Gestió de despatx",
  Juntas: "Juntes",
  Votaciones: "Votacions",
  VotacionesOrdenDia: "Ordre del dia/Votacions",
  ZonasComunes: "Zones Comuns",
  Documentacion: "Documentació",
  Actividades: "Activitats",
  Actividad: "Activitat",
  DescJuntas: "Gestió de Juntes",
  DescVotaciones: "Gestió de Votacions",
  DescZonasComunes: "Gestió de Zones Comuns",
  DescDocumentacion: "Gestió de Documentació",
  DescActividades: "Gestió d'activitats",
  Detalle: "Detall",
  Mostrando: "Mostrant",
  a: "a",
  de: "de",
  resultados: "resultats",
  HasSeleccionado: "Heu seleccionat",
  comunidades: "comunitats",
  paraAviso: "per a l'enviament d'AVÍS",
  comunidad: "comunitat",
  Comunidad: "Comunitat",
  exportarPdf: "Exportar a PDF",
  exportarCsv: "Exportar a CSV",
  filasPagina: "Files per pàgina",
  comunidadesSeleccionadas: "comunitat/s seleccionada/des per avís.",
  CERRAR: "TANCAR",
  Restaurar: "Restaurar",
  tituloFormAvisos: "Enviament avisos",
  asunto: "Assumpte",
  textoAviso: "Text de l'avís",
  URLopcional: "URL opcional",
  diagoloTitulo: "Baixa de la comunitat",
  diagoloBody: "¿Esteu segur que voleu donar de baixa la comunitat?",
  cerrar: "Tancar",
  guardarCambios: "Desar canvis",
  diagoloBodyAviso: "Esteu segur que voleu enviar l'avís?",
  diagoloTituloAviso: "Enviament d'avís",
  Guardar: "Desa",
  CNAE: "CNAE",
  TlfnPrincipal: "Telèfon (Si n'hi ha més d'un han d'anar separats per comes)",
  TlfnSecundario: "Telèfon secundari",
  Email1: "Email (Si n'hi ha més d'un han d'anar separats per comes)",
  Email2: "Email 2",
  idProveedor: "Id Proveïdor",
  idComunidad: "Id Comunitat",
  fechaInicioContrato: "Data inici contracte",
  fechaFinContrato: "Data fi contracte",
  observaciones: "Observacions",
  sinresultados: "No s'han trobat resultats.",
  cancelar: "Cancel·la",
  aceptar: "Acceptar",
  Grupos: "Grups",
  AccesoATodo: "Accés a tot",
  Documentacion: "Documentació",
  ZonasReserva: "Zones de reserva",
  JuntasYVotaciones: "Juntes i votacions",
  Observaciones: "Observacions",
  Opciones: "Opcions",
  Acciones: "Accions",
  tip_BorrarRol: "Clica per esborrar un rol",
  confirmarBorradoRol: "Has marcat un rol per donar-lo de baixa, vols continuar?",
  tituloConfirmarBorradoRol: "Confirmar esborrat",
  Anadir: "Afegir",
  Proveedores: "Proveïdors",
  SoloPara: "Només per a:",
  Roles: "Rols",
  Numero: "Número",
  Portal: "Portal",
  Escalera: "Escala",
  Piso: "Pis",
  Letra: "Lletra",
  Inquilino: "Inquilí",
  Multipropiedad: "Multipropietat",
  Bloqueado: "Bloquejat",
  Bloq: "Bloq.",
  Usuario: "Usuari",
  AdministradorFincaColegiado: "Administrador de Finques Col·legiat",
  EmpleadoOficina: "Empleat d'Oficina",
  RegistroHorario: "Fitxatges",
  Ano: "Any",
  SeleccionaAno: "Selecciona un any",
  Entrada: "Entrada",
  Salida: "Sortida",
  Centro: "Centre",
  Horas: "Hores",
  Semana: "Setmana",
  Fecha: "Data",
  TotalHoras: "Total Hores",
  Minutos: "Minuts",
  Modificar: "Modificar",
  Eliminar: "Eliminar",
  Filtrar: "Filtrar",
  tituloNuevoRegistroHorario: "Nou registre horari",
  confirmarBorradoRegistroHorario: "Vols esborrar el registre horari?",
  tituloConfirmarBorradoRistroHorario: "Esborrar registre horari",
  EnviarCheckEmail: "Enviar Emails de verificació",
  tituloModificarRegistroHorario: "Modificar registre horari",
  MiCarpeta: "La meva Carpeta",
  ReseteoContrasena: "Reseteig Contrasenya",
  TextoReseteoContrasena:
    "Es resetejarà la contrasenya de l'usuari, en el moment que es faci l'actualització l'usuari haurà d'accedir a l'aplicació amb la contrasenya nova",
  AnadeContrasena: "Afegeix la contrasenya nova (almenys 6 dígits)",
  Borrar: "Esborrar",
  Todo: "Tot",
  Reservas: "Reserves",
  ReservasDe: "Reserves lliures de",
  Despachos: "Despatxos",
  hasCambiadoDespacho: "Ara ets al despatx",
  enviarAviso: "Enviar Avís",
  DNI: "DNI",
  descripcion: "Descripció",
  tipo: "Tipus",
  EliminarUsuario: "Eliminar Usuari",
  ConfirmarEliminarUsuario: "Vols eliminar l'usuari?",
  DetalleActividad: "Detall de l'activitat",
  AnadirActividad: "Afegir activitat",
  tip_BorrarActividad: "Clica per esborrar una activitat",
  confirmarBorradoActividad:
    "Has marcat una activitat per donar-la de baixa, aquesta desapareixerà de totes les teves comunitats, vols continuar?",
  tituloConfirmarBorradoActividad: "Confirmar esborrat",
  AnadirRol: "Afegir Rol",
  confirmarBorradoVoto: "Has marcat un vot per esborrar-lo, vols continuar?",
  tituloConfirmarBorradoVoto: "Confirmar esborrat",
  Icono: "Icona",
  Si: "Si",
  No: "No",
  cuerpoDesBloquearUsuario: "Vols desbloquejar l'usuari ",
  tituloDesBloquearUsuario: "¿Desbloquejar usuari ",
  cuerpoBloquearUsuario: "¿Voleu bloquejar l'usuari ",
  tituloBloquearUsuario: "Bloquejar usuari ",
  Porcentaje: "Percentatge",
  Proveedor: "Proveïdor",
  SeleccionaProveedor: "Cerca i selecciona un proveïdor...",
  UsuariosRegistradores: "Usuaris registradors",
  FalloPago: "El pagament ha fallat, torna a intentar-ho més tard.",
  Gobierno: "Junta de govern",
  Administración: "Administració",
  Mantenimiento: "Manteniment",
  tituloEnvioCorrecto: "Resultat de l'enviament",
  mensajeResultados: "Avís enviat correctament a ${var1} destinataris",
  tip_BorrarGremio: "Clica per esborrar un proveïdor",
  confirmarBorradoGremio: "Has marcat un proveïdor per donar-lo de baixa, vols continuar?",
  tituloConfirmarBorradoGremio: "Confirmar esborrat",
  preciosSinIva: "Tots els preus són sense IVA.",
  preciosPorVecino:
    "Els preus varien depenent del nombre de veïns de la comunitat. (Aquesta comunitat té ${var1} veïns)",
  preciosPorVecinoHistorico:
    "Els preus varien depenent del nombre de veïns de la comunitat. (Aquesta comunitat tenia ${var1} veïns en el moment de la contractació)",
  CreadoPor: "Creat per",
  estadoContrato: "Estat",
  asociarActividad: "L'activitat ara sortirà al mòbil dels usuaris de la comunitat.",
  desasociarActividad: "L'activitat ja no sortirà al mòbil dels usuaris de la comunitat.",
  asociarTodasActividades:
    "Ara sortiran totes les activitats al mòbil dels usuaris de la comunitat",
  desasociarTodasActividades: "Ara no sortirà cap activitat al mòbil dels usuaris de la comunitat",
  EnvioAvisoEmail: "A més de l'avís, enviar també per correu electrònic als implicats",
  Codigo: "Codi",
  Tipo: "Tipus",
  Actividad: "Activitat",
  Registrador: "Registrat per",
  // Registrador: "Registrador",
  tip_BorrarIncidencias: "Clica per esborrar la incidència",
  tip_BorrarNotificaciones: "Clica per esborrar la notificació",
  notificacionBorrada: "Notificació esborrada",
  tip_BorrarVotacion: "Clica per esborrar la votació",
  tip_compartirIncidencia: "Compartir/publicar la incidència",
  tip_ModificarRegistroHorario: "Clica per editar el registre",
  tip_BorrarRegistroHorario: "Clica per esborrar el registre",
  tip_BorrarReserva: "Clica per cancel·lar la reserva",
  tituloCriticos: "S'han canviat dades crítiques!",
  bodyCriticos:
    "Es retornaran els abonaments als usuaris i s'esborraran les reserves futures per poder desar la configuració",
  Compartir: "Compartir",
  red: "Vermell",
  yellow: "Groc",
  green: "Verd",
  incidenciaGreen: "Incidència tancada o cancel·lada",
  incidenciaYellow: "Incidència en curs",
  incidenciaRed: "Incidència sense tancar des de fa 8 dies o més",
  incidenciaRed2: "Incidència oberta",
  ENVIAR_AVISO_EMAIL: "Enviar Email de Registre",
  adminDesk: {},
  SeleccionaComunidad: "Selecciona una comunitat",
  SeleccionaEstado: "Selecciona un estat",
  SeleccionaActividad: "Selecciona una activitat",
  SeleccionaProveedor2: "Selecciona un proveïdor",
  Estado: "Estat",
  ABIERTA: "OBERTA",
  CERRADA: "TANCADA",
  CANCELADA: "CANCEL·LADA",
  ENCURSO: "EN CURS",
  SeleccionaTipo: "Selecciona tipus",
  INCIDENCIA: "AVARIA",
  SINIESTRO: "SINISTRE",
  SOLICITUD: "SOL·LICITUD",
  CONSULTA: "CONSULTA",
  AVISO: "AVÍS",
  SOS: "SOS",
  NuevaIncidencia: "Nova incidència",
  DetalleIncidencia: "Detall de la incidència",
  DetalleVotacion: "Detall de la votació",
  CodigoDespacho: "Codi de despatx",
  CodigoComunidad: "Codi de comunitat",
  SeleccionaRegistrador: "Selecciona un registrador",
  DescripcionIncidencia: "Descripció de la incidència (visible pels usuaris de l'app)",
  DatosGuardadosCorrectamente: "Dades desades correctament.",
  ErrorGuardarDatos: "Error en desar les dades.",
  mensajeDespublicarIncidencia:
    "En desactivar aquesta opció la incidència serà privada per als veïns de la comunitat.",
  mensajePublicarIncidencia:
    "En activar aquesta opció la incidència serà pública per a tots els veïns de la comunitat. Qualsevol modificació i posterior enviament d'avís es farà a tots els propietaris registrats.",
  Fecha_Modificacion: "Data de modificació",
  EmailProveedor: "Email proveïdor",
  TelefonoProveedor: "Telèfon proveïdor",
  ActualizaDescripcionInterna:
    "Notes internes de la incidència (visibles només pels administradors i empleats d'oficina)",
  HistoricoDescripcionInterna: "Històric de la incidència",
  HistoricoDescripcionInternaVota: "Històric de la votació",
  TituloBorrarIncidencia: "Confirma l'esborrament d'incidència",
  CuerpoBorrarIncidencia: "Per marcar la incidència com a esborrada prem 'acceptar'.",
  TituloCompartirIncidencia: "Confirmar compartir incidència",
  CuerpoCompartirIncidencia: "Per compartir la incidència prem 'acceptar'.",
  IncidenciaBorradaCorrectamente: "Incidència esborrada correctament",
  errorBorrarIncidencia: "Error en esborrar la incidència",
  errorBorrarNotificacion: "Error en esborrar la notificació",
  NotificacionBorradaCorrectamente: "Notificació esborrada correctament",
  IncidenciaCompartidaCorrectamente: "Incidència compartida correctament",
  errorCompartirIncidencia: "Error en compartir la incidència",
  incidenciaBorrada: "Incidència esborrada",
  votacionBorrada: "Votació esborrada",
  notifiacionBorrada: "Notificació esborrada",
  incidenciaCompartida: "Incidència compartida",
  datosRefrescados: "Dades refrescades",
  Documentacion: "Documentació",
  DocumentacionAdjunta: "Documentació adjunta",
  DocumentacionAdjuntaDesc: "Documents associats a la incidència",
  DocumentacionAdjuntaDesc2: "Documents associats a la notificació",
  arrastraArchivos: "Arrossega i deixa anar els teus fitxers per pujar-los a la carpeta",
  TextoPropiedadDocumentos:
    "* Tots els documents pujats a C365 són propietat de la comunitat, i seran traspassats en cas de canvi d'administrador. Si consideres que un document no ha de ser traspassat, si us plau, indica-ho a l'opció “Modificar” d'aquest document",
  textoConfirmarBorradoCarpeta: "Estàs segur que vols esborrar la carpeta?",
  textoConfirmarBorradoCarpetaGeneral:
    "Estàs segur que vols esborrar la carpeta? La carpeta s'esborrarà de totes les comunitats",
  tituloConfirmarBorradoCarpeta: "Esborrar carpeta:",
  textoConfirmarBorradoFichero: "Estàs segur que vols esborrar el fitxer?",
  textoConfirmarBorradoFicheroGeneral:
    "Estàs segur que vols esborrar el fitxer? El fitxer s'esborrarà de totes les comunitats",
  tituloConfirmarBorradoFichero: "Esborrar fitxer:",
  ExitoBorradoFichero: "Fitxer esborrat correctament",
  FalloBorradoFichero: "Error en esborrar el fitxer",
  Descargar: "Descarregar",
  SeleccionaCompaniaSeguros: "Selecciona CIA d'Assegurances",
  PolizaSeguros: "Pòlissa d'assegurances",
  Direccion_es: "Adreça/es",
  PorcentajeTotalPropiedad: "% Total",
  TotalReservas: "Total Reserves",
  PorcPropiedad: "% Propietat",
  ViviendaInquilino: "Habitatge amb Llogater",
  ViviendaRepLegal: "Habitatge amb Rep. legal",
  propietario: "Propietari",
  inquilino: "Llogater",
  representantelegal: "Representant Legal",
  empresa: "Empresa",
  ViviendasTipo: "Habitatges / Tipus",
  SinViviendas: "Sense habitatges",
  AltaCorrecta: "Donat de baixa correctament.",
  FalloBajaComunidad: "Error en donar de baixa la comunitat",
  ComunidadNoAlta: "La comunitat no està d'alta.",
  ErrorGuardadoDatos: "Error en desar les dades.",
  ErrorDatosExistentes: "L'activitat ${var1} ja existeix, si us plau utilitza un altre nom.",
  DatosActualizadosCorrectamente: "Dades actualitzades correctament",
  ActividadBorradaCorrectamente: "Activitat esborrada correctament",
  ActividadExistente: "L'activitat ${var1} ja existeix, si us plau utilitza un altre nom.",
  FechaAlta: "Data d'alta",
  CodigoVecino: "Codi Veí",
  CodigoPostal: "Codi postal",
  NumeroVecinos: "Número de Veïns",
  Siniestros: "Sinistres",
  ModificacionClientes: "Rebre Sol·licituds",
  ConsultasAdmin: "Rebre Consultes",
  ConsultasSeguros: "Consultes assegurances",
  Categoria: "Categoria",
  Alta: "Alta",
  ConfirmarBajaComunidad:
    "Estàs segur que vols donar de baixa la comunitat amb id ${var1} de C365?",
  MaximoArchivos: "Només pots pujar fins a un màxim de ${var1} arxius",
  TipoArchivoNoPermitido: "Tipus de fitxer no permès: ${var1}",
  ArchivoTamañoMaximoSuperado: "El fitxer ${var1} excedeix la mida màxima permesa de ${var2} MB",
  ArchivosSubidosCorrectamente: "Arxius pujats correctament.",
  NombreCarpetaVacio: "El nom de la carpeta no pot estar buit.",
  MismoNombreArchivoMismoNivel: "No pots posar el mateix nom a un document del mateix nivell",
  CarpetaCreadaCorrectamente: "Carpeta creada correctament.",
  ErrorCrearCarpeta: "Error en crear la carpeta.",
  CarpetaMovidaCorrectamente: "Fitxer/Carpeta mogut correctament.",
  ErrorMoverCarpeta: "Error en moure el fitxer/carpeta.",
  ErrorMoverCarpetaNoPermitido:
    "No pots moure les carpetes protegides de Juntes de propietaris i Documentació general",
  Carpeta03NoBorrar: "La carpeta Juntes de Propietaris no es pot esborrar/modificar",
  GuardarCambiosModificar: "Per desar els canvis has de modificar el fitxer",
  ErrorCambiarTransferibilidad: "Error en canviar la transferibilitat",
  NombreCambiadoCorrectamente: "Nom canviat correctament.",
  ErrorCambiarNombre: "Error en canviar el nom.",
  TipoArchivoNoPermitido: "Tipus de fitxer no permès",
  DocumentosComunidad: "Documents de la comunitat",
  Busqueda: "Cerca",
  CarpetaActual: "Carpeta actual :",
  NombreCarpeta: "Nom de la carpeta",
  Descargar: "Descarregar",
  Borrar: "Esborrar",
  EnviarAviso: "Enviar avís",
  AvisoDocumentosSubidosC365:
    "Tots els documents pujats a C365 són propietat de la comunitat, i seran traspassats en cas de canvi d'administrador. Si consideres que un document no ha de ser traspassat, si us plau, indica-ho en l'opció “Modificar” d'aquest document",
  SeleccionarCarpetaMostrarDetalle: "Selecciona una carpeta per mostrar-ne el detall",
  TipoArchivoNoPermitido: "Tipus de fitxer no permès: ${var1}",
  TodoOk: "Tot ok",
  GremioCreadoConecta: "El proveïdor ha estat creat per CAFPortal o no té associada activitat",
  ProveedorBaja: "El proveïdor ha estat donat de baixa",
  CasoNoCompletado: "Cas no contemplat",
  FechaAlta: "Data Alta",
  FechaBaja: "Data Baixa",
  GremioBorradoCorrectamente: "proveïdor esborrat correctament",
  Comus: "comus",
  CambioEstado: "Canvi d'estat",
  NotificacionUsuarioAceptarOCancelar:
    "Pots enviar notificació a l'usuari registrador, a l'administrador i un e-mail al proveïdor sobre la actualització de la incidència (EN CURS) o (OBERTA) prem ACCEPTAR o CANCEL·LAR",
  CambioEstadoIncidencia: "Canvi d'estat d'incidència",
  CambioEstadoIncidenciaCodigo:
    "S'ha canviat d'estat la incidència amb codi ${var1} de ${var2} a ${var3}",
  CambioEstadoIncidenciaCodigoCerrada:
    "S'ha canviat d'estat la incidència amb codi ${var1} ha estat tancada ",
  ArchivoExcedeTamano: "El fitxer excedeix la mida màxima permesa de ${var1} MB",
  CambioTipo: "Canvi de tipus",
  NotificacionIncidenciaAceptarOCancelar:
    "Pots enviar notificació a l'usuari registrador, a l'administrador i un e-mail al proveïdor sobre el canvi del tipus d'incidència a SINISTRE, prem “ACCEPTAR” o “CANCEL·LAR”.",
  CambioTipoIncidencia: "Canvi de tipus d'incidència",
  CambiadoTipoIncidenciaCodigo: "S'ha canviat el tipus de la incidència amb codi ",
  CambiadoTipoAveriaCodigo:
    "Pots enviar notificació a l'usuari registrador, a l'administrador i un e-mail al proveïdor sobre el canvi del tipus d'incidència a AVARIA, prem “ACCEPTAR” o “CANCEL·LAR”.",
  FechaModificacion: "Data modificació",
  FechaCreacion: "Data creació",
  NombreRegistrador: "Nom Registrador",
  ApellidoRegistrador: "Cognom Registrador",
  RolExiste: "El rol ${var1} ja existeix, si us plau utilitza un altre.",
  DatosRefrescados: "Dades refrescades",
  RolBorradoCorrectamente: "Rol esborrat correctament",
  LimpiarBusqueda: "Netejar cerca",
  LimpiarSeleccionado: "Netejar seleccionat",
  NoHayRoles: "No hi ha rols",
  SeleccionarTodos: "Seleccionar tots",
  SeleccionarTodosFiltrado: "Seleccionar tots (filtrat)",
  RolSeleccionado: "Rol seleccionat...",
  EmailYaExiste: "L'Email ja existeix",
  DNIYaExiste: "El DNI ja existeix",
  NumeroYaExiste: "Ja existeix aquest número per a una junta en aquesta comunitat",
  TituloYaExiste: "Ja existeix aquest títol per a una junta en aquesta comunitat",
  CompletaCamposObligatiorio: "Si us plau, completa tots els camps obligatoris.",
  NoValidoIntroduceCorrecto: "El NIF/NIE no és vàlid, n'introdueix un de correcte",
  NoValidoIntroduceCorrecto2: "El NIF/NIE/CIF no és vàlid, n'introdueix un de correcte",
  NoValidoIntroduceCorrecto3: "El NIF/CIF no és vàlid, n'introdueix un de correcte",
  FotoBorradaCorrectamente: "Foto esborrada correctament.",
  FotoGuardadaCorrectamente: "Foto guardada correctament.",
  AnadirUsuario: "Afegir Usuari",
  FechaIncorrecta: "La data és incorrecta.",
  NoFechasVacias: "No es pot deixar una de les dates buida",
  HorasMinutos: "Hores minuts",
  RegistroHorarioBorrado: "Registre horari esborrat correctament",
  ErrorBorrandoRegistro: "Error esborrant registre",
  HoraSalidaEntradaIncorrecta: "L'hora de sortida no pot ser menor que la d'entrada",
  TodosRolesSeleccionados: "Tots els rols han estat seleccionats.",
  SeleccionarRoles: "Seleccionar rols",
  RegistroInquilinoCambiado: "Registre de llogater canviat.",
  ErrorGuardarDatos: "Error en desar les dades",
  UsuarioEliminadoCorrectamente: "Usuari eliminat correctament.",
  FalloEliminarUsuario: "Hi va haver un error en esborrar l'usuari.",
  DNIExisteOtroUsuario: "El DNI ja existeix a un altre usuari",
  EmailExisteOtroUsuario: "L'Email ja existeix a un altre usuari",
  ContrasenaActualizadaNuevaContrasena: "La contrasenya ha estat actualitzada. Nova contrasenya: ",
  EmailActualizado: "El nom d'usuari ha estat actualitzat. Nou usuari: ",
  ErrorCambiarContrsena: "Error en canviar la contrasenya.",
  ErrorCambiarEmail: "Error en canviar l'email/nom d'usuari.",
  ErrorEnviandoEmailConfirmacion: "Error enviant el correu electrònic de verificació: ",
  EnviadoCorreoConfirmacionA: "S'ha enviat el correu de verificació a ",
  AltaC365: "AltaC365",
  CodigoCompletisimo: "codi Completíssim",
  VotoBorradoCorrectamente: "Vot esborrat correctament",
  TipoVotacion: "Tipus de votació",
  Publicar: "Publicar",
  AperturaVotacion: "Obertura votació",
  ResultadoPublicado: "Resultat publicat",
  PublicadoPorPorciento: "Publicat per %",
  AltaComunidadConfigurar:
    "Ja tens d'alta aquesta comunitat a c365, segueix els següents passos per configurar la teva comunitat:",
  BienvenidoC365: "¡Benvingut a c365!",
  GeneraCodigoVecinos:
    "Fes arribar als teus veïns el Codi de Registre Comunitat o el Codi de Registre Veí perquè es puguin registrar a l'app.",
  CompletaDatosProveedoresGestionIncidencias:
    "Completa les dades dels teus proveïdors contractats per gestionar incidències i sinistres.",
  MarcarActividades:
    "Marca les activitats sobre les que vulguis que els teus veïns puguin passar incidències.",
  CompletaDocumentos: "Puja la documentació que vulguis compartir amb els propietaris.",
  IncidenciasYproveedores:
    "Si vols que les incidències d'una activitat arribin directament a un proveïdor (a més de l'administrador) dóna d'alta els contractes en proveïdors o en activitats.",
  SubeDocumentos: "Puja la documentació que vulguis compartir amb els propietaris.",
  CreaVotacionesJuntas: "Prepara votacions i juntes quan sigui necessari.",
  CreaZonasComunes: "Configura les zones comunes (si tens contractat el Pack de Zones Comunes).",
  HabilitaFichajes:
    "Fes arribar als teus veïns el Codi de Registre Comunitat o el Codi de Registre Veí perquè es puguin registrar a l'app.",
  SubeDoucmentacionComparte:
    "Puja la documentació que vulguis i comparteix-la amb els propietaris.",
  PreparaVotacionesJuntas: "Prepara votacions o juntes quan sigui necessari.",
  ConfiguraZonasComunes:
    "Configura les zones comunes (si tens contractat el Pack de Zones Comunes).",
  HabilitaEmleadosFichar:
    "Habilita als empleats perquè puguin fitxar (si tens contractat el Pack Control Horari).",
  MarcarEnviarAviso: "Marcar per enviar avís",
  MarcarEnviarAvisoRegistroVecino: "Marcar per enviar avís o enviar codi de registre veí",
  UsuariosActivosComunidades: "Usuaris Actius / Comunitats",
  UsuariosComunidad: "Usuaris Comunitat",
  ComunidadesActivasUsuarios: "Comunitats Actives / Usuaris",
  ComusUsuarios: "Comus Usuaris",
  IncidenciasEstados: "Incidències/Estats ",
  EstadoNumero: "Estat/Número",
  IncidenciasAverias: "Incidències Avaries/Tipus",
  IncidenciasTodas: "Incidències totes ",
  CodigoDespacho: "Codi de despatx",
  Refrescar: "Refrescar",
  Volver: "Tornar",
  AltaDesde: "Alta des de",
  AltaHasta: "Alta fins a",
  NOTIFICACIONES: "NOTIFICACIONS",
  CUADRODEMANDOS: "QUADRE DE COMANDAMENTS",
  TODAS: "TOTES",
  ACTIVAS: "ACTIVES",
  TODOS: "TOTS",
  ACTIVOS: "ACTIUS",
  ABIERTA: "OBERTA",
  ENCURSO: "EN CURS",
  CANCELADA: "CANCEL·LADA",
  CERRADA: "TANCADA",
  Desde: "Des de",
  Hasta: "Fins a",
  hasta: "fins a",
  bloquearReservaTitutlo: "Bloqueig de reserva",
  CerrarSesion: "Tancar sessió",
  ErrorDemasiadosIntentos: "Massa intents, si us plau espera una estona abans de repetir l'acció.",
  ErrorCamposRequeridos:
    "Els camps ressaltats en vermell són obligatoris. Per desar els canvis han d'estar farcits.",
  ValorAntiguo: "Valor anterior",
  ValorActual: "Valor actual",
  Estado: "Estat",
  Tipo: "Tipus",
  Actividad: "Activitat",
  Proveedor: "Proveïdor",
  NombreRegistrador: "Registrador",
  NombreResponsable: "Responsable",
  Texto_publicar: "Descripció",
  Email: "Email",
  Email2: "Email 2",
  Telefono1: "Telèfon",
  Telefono2: "Telèfon 2",
  Notas: "Notes internes",
  DerechoDeReservas: "Dret de Reserves",
  sendRegistrationCodeModaltitle: "Enviar codi Registre",
  sendRegistrationCodeModalConfirm:
    "Aquesta acció enviarà per correu les instruccions i credencials necessaris per registrar-se a l'app a l'usuari: ",
  sendRegistrationCodesModalConfirm:
    "Aquesta acció enviarà per correu les instruccions i credencials necessaris que per registrar-se a l'app a tots els usuaris seleccionats que no estiguin donats d'alta al sistema.",
  sendRegistrationCodeModalSaveMail: "L'Email ha estat modificat, Desar canvis i continuar?",
  sendRegistrationCodeAllowedTip: "Enviar Codi de registre per mail",
  sendRegistrationCodeDeniedTip: "No és possible enviar sense email",
  sendRegistrationCodeSucess: "Correu enviat correctament.",
  sendRegistrationCodeFailure:
    "Ha passat un problema enviant el correu, intenta-ho de nou més tard.",
  sendRegistrationCodesSucess: "Correus enviat correctament.",
  sendRegistrationCodesFailure:
    "Ha passat un problema enviant els correus, intenta-ho de nou més tard.",
  sendRegistrationCodesMissingMail:
    " no teniu correu, introduïu-lo en el detall o deseleccioneu l'usuari abans de continuar.",
  RazonSocial: "Raó Social",
  Correo: "Correu",
  PersonaDeContacto: "Persona de contacte",
  DatosDespacho: "Dades del despatx",
  NombreYapellidos: "Nom i Cognoms",
  tituloBorradoIncidencia: "Incidència ${var1} esborrada",
  tituloCompartidoIncidencia: "Incidència ${var1} compartida",
  mensajeBorradoIncidencia:
    "La incidència amb codi ${var1}. INCIDÈNCIA ha estat esborrada, prem el link per veure'n el detall",
  mensajeCompartidoIncidencia:
    "La incidència amb codi ${var1}. INCIDÈNCIA ha estat compartida, prem el link per veure'n el detall",
  ResultadoPublicadoPorPorciento: "Resultat publicat per %",
  ErrorNoArchivoBorrar: "Error, no ha arribat cap fitxer a esborrar",
  PUBLICADA: "PUBLICADA",
  NOPUBLICADA: "NO PUBLICADA",
  SINOABS: "SI/NO/ABS",
  OPCIONES: "OPCIONS",
  NuevaOpcionDeVotacion: "Nova opció de votació",
  TituloBorrarVotacion: "Esborrar votació",
  CuerpoBorrarVotacion: "Estàs segur que vols esborrar la votació?",
  AnadirVotacion: "Afegir votació",
  ElFicheroExisteNoModificar: "El fitxer ${var1} ja existeix i no es pot modificar",
  EnviarCambiosRealizados: "S'enviaran els canvis realitzats a l'usuari/s i administrador",
  CambiarEstadoCerradaNoModificar:
    "Vols canviar l'estat a TANCADA?, si el canvies ja no podràs modificar la incidència",
  IncidenciaActualizadaCorrectamente: "La incidència s'ha actualitzat correctament",
  IncidenciaCerradaCambioAdministrador:
    "La incidència està tancada, si vols fer algun canvi posa't en contacte amb l'administrador, gràcies",
  IncidenciaCanceladaCambioAdministrador:
    "La incidència està cancel·lada, si vols fer algun canvi posa't en contacte amb l'administrador, gràcies",
  IncidenciaNoExiste: "La incidència no existeix.",
  BorrarEstadoAbierta: "Per poder esborrar l'estat de la incidència ha d'estar OBERTA",
  ArrastraFicheroCargarloVentana:
    "Arrossega el fitxer o fes clic aquí per carregar-lo des de la finestra",
  CargarFicheroAdjuntarFoto: "Fes clic aquí per carregar un fitxer o adjuntar una foto",
  AnadeComentariosEnvialo: "Afegeix comentaris i envia'ls",
  TextoAnadir: "Text a afegir",
  NombreZona: "Nom zona",
  DescripcionIncidencia: "Descripció de la Incidència",
  UltimaModificacion: "Última Modificació",
  GremioResponsable: "Proveïdor Responsable",
  ImagenAsociada: "Imatge associada: ",
  Gremio: "proveïdor: ",
  Incidencia: "Incidència: ",
  CentrosTrabajo: "Centres de treball",
  DocumentacionGeneral: "Documentació general",
  TodosCorreos: "Tots els correus",
  RecibirIncidencias: "Rebre Avaries",
  RecibirSiniestros: "Rebre Sinistres",
  RecibirModificacionClientes: "Rebre Sol·licituds",
  RecibirConsultaAdmin: "Rebre Consulta Administrador",
  RecibirConsultaSeguros: "Rebre Consulta Assegurances",
  RecibirConsultas: "Rebre Consultes",
  CategoriaUsuarioAdministrador: "Categoria Usuari-Administrador",
  Rol: "Rol",
  Fichar: "Fitxar",
  ResetearContrasena: "Resetejar Contrasenya",
  VerificarEmail: "Verificar correu",
  Eliminar: "Eliminar",
  DetallesUsuario: "Detalls Usuari",
  FechaUltimoAcceso: "Data Últim Accés",
  FechaCreacion: "Data Creació",
  AnadirRegistro: "Afegir Registre",
  HorasEntrada: "Hores Entrada",
  HorasSalida: "Hores Sortida",
  Latitud: "Latitud",
  Longitud: "Longitud",
  Distancia: "Distància",
  VotacionaBorradaCorrectamente: "Votació esborrada correctament",
  AnadirCentroDeTrabajo: "Afegir Centre de treball",
  CodigoAdministrador: "Codi d'Administrador",
  DatosCentroDeTrabajo: "Dades Centre de treball",
  CentrosTrabajoDespacho: "Centres de treball del despatx",
  CentrosTrabajoComunidad: "Centres de treball comunitat",
  AvisoActividadSinProveedor:
    "Els administradors rebran sempre les incidències per activitat, si vols que les rebi també un proveïdor en concret associa'l des del detall del proveïdor.",
  AlertaIncidenciaCompartida:
    "La incidència ja va ser compartida. Accedeix al detall per descompartir.",
  DocumentoAnadido: "Document afegit",
  DocumentoEliminado: "Document eliminat",
  textoEnviarActualizaciones:
    "Enviar emails i notificacions als implicats avisant dels canvis en la incidència",
  tituloEnviarActualizaciones: "Confirmar desat",
  tip_BorrarZonaComun: "Confirma l'operació d'esborrament",
  confirmarBorradoZonaComun: "Estàs segur que vols esborrar la zona comuna?",
  ZonaComunBorradaCorrectamente: "Zona comuna esborrada correctament",
  tituloConfirmarBorrado: "Confirmar esborrat",
  UsuariosDespacho: "Usuaris del Despatx",
  zonaPiscina: "Piscina",
  zonaPadel: "Pista Pàdel",
  zonaTenis: "Pista Tennis",
  zonaSalaReuniones: "Sala de Reunions",
  zonaGimnasio: "Gimnàs",
  zonaOtros: "Altres",
  zonaBarbacoa: "Barbacoa",
  zonaJardinJuegos: "Jardí/Zona jocs",
  zonaFronton: "Frontó",
  zonaSalaInfantil: "Sala infantil",
  zonaSolarium: "Solàrium",
  zonaSpa: "Spa",
  zonaPiscina2: "Piscina II",
  zonaBus: "Bus",
  CentroTrabajoCerradoCorrectamente: "Centre de treball esborrat correctament",
  tip_BorrarCentroTrabajo: "Prem per esborrar el centre de treball",
  centroDeTrabajoBorrado: "Centre de treball esborrat",
  CuerpoBorrarCentroTrabajo: "Per esborrar el centre de treball prem 'acceptar'.",
  TituloBorrarCentroTrabajo: "Confirmar esborrat del centre de treball",
  Historial: "Historial de reserves",
  tip_historialReservas: "Prem per veure l'historial de reserves de la zona comuna",
  HoraInicio: "Hora inici",
  HoraFin: "Hora fi",
  Administrador: "Administrador",
  Oficial: "Oficial",
  Auxiliar: "Auxiliar",
  CamposVacios: "Els camps en vermell no poden estar buits",
  SeleccionaUnaOpcion: "Selecciona una opció",
  AnadirUsuario: "Afegir Usuari",
  PersonasIncluidas: "Persones incloses",
  Enteros: "Enters",
  AnadirZonaComun: "Afegir zona comuna",
  DetalleZonaComun: "Detall de la zona comuna",
  NombreZona: "Nom zona",
  TipoZona: "Tipus de zona",
  NumeroPersonasReserva: "Número de persones permeses per reserva",
  NumeroReservasPorDia: "Número de reserves per dia/persona",
  HorizonteDeFechas: "Horitzó de Dates",
  Aforo: "Aforament",
  SlotsSeguidos: "Slots seguits permesos per reserva",
  AperturaDiaSiguiente: "Obrir següent dia de reserva a partir de les:",
  //LimitacionesReserva: "Limitacions si Reserva Activa",
  LimitacionesReserva: "Permetre reservar si reserva Activa",
  MostrarPortalPiso: "Mostrar Portal, Pis, Lletra del que ha reservat",
  NoPermitirReservarSiReserva: "No permetre reservar si Reserva Activa No consumida",
  MargenCancelacionReserva: "Marge de cancel·lació de reserva",
  NumeroPersonas: "Número de persones",
  SeleccionaNumpersonas: "Selecciona el número de persones",
  SeleccionaNumreservas: "Selecciona el número de reserves per persona/dia",
  persona: "persona",
  personas: "persones",
  reserva: "reserva",
  reservas: "reserves",
  NoAplica: "No aplica",
  dias: "dies",
  dia: "dia",
  SeleccionaHorizonte: "Selecciona el número de dies",
  SeleccionaSlotsSeguidos: "Selecciona el número",
  Slot: "Slot",
  Slots: "Slots",
  SeleccionaPermitirReservarHora: "Selecciona l'hora",
  limitaciones1: "SENSE LIMITACIONS",
  limitaciones2: "Només a partir de l'hora d'aplicació, per al dia següent",
  limitaciones3: "Només el mateix dia de Reserva Activa fins a consumir les del dia",
  limitaciones4: "Només pots reservar amb un mínim d'hores de diferència",
  limitaciones5: "Alliberar el següent slot després d'unes hores",
  SeleccionaLimitaSiReserva: "Selecciona l'opció",
  LimiteHoraCancelacion: "Límit hora cancel·lació",
  Resetear: "Resetejar",
  ResetearVotacionBody: "Estàs segur que vols resetejar la votació?",
  VotacionResetearCorrectamente: "Votació resetejada correctament",
  ZonaComunExiste:
    "La zona comuna ${var1} ja existeix per a la comunitat actual, si us plau escriu un altre nom.",
  ControlStockReservas: "Control d'estoc de reserves",
  visibleSoloAdmin: "VISIBLE NOMÉS PER L'ADMIN",
  limiteReservasUsuario: "Límit reserves/usuari",
  tipoControlStock: "Tipus de control d'estoc",
  permitirReservarSinStock: "Permetre reservar en l'hora actual sense tenir estoc",
  consumirStockReservaActual: "Consumir de l'estoc reservant en l'hora actual",
  consumirStockAunCancelando: "Consumir de l'estoc encara que es cancel·li la reserva",
  noConsumirStockDiaReserva: "No consumir estoc el mateix dia de la reserva",
  tipoControlStock1: "Per setmana",
  tipoControlStock2: "Per mes",
  tipoControlStock3: "Per any",
  tipoControlStock4: "Per temporada",
  tipoControlStock5: "Per dies",
  SeleccionaTipoControlStock: "Selecciona el tipus",
  FechaInicio: "Data inici",
  FechaFin: "Data fi",
  FormaDePago: "Forma de pagament",
  noConsumirDesdeDia: "No consumir des del dia",
  noConsumirAPartir: "No consumir estoc a partir de les",
  desdedia0: "Cap dia abans",
  desdedia1: "dia abans",
  desdedia2: "dies abans",
  SeleccionaDiasAntesSinConsumir: "Selecciona els dies",
  ControlAbonos: "Control d'Abonaments",
  ControlInvitados: "Control de Convidats",
  AperturaAutomaticaPuerta: "Obertura automàtica porta",
  GestionHorarios: "Gestió horaris",
  NumInvitadosPorReserva: "Número màxim de convidats per reserva",
  NumConvivientesPorReserva:
    "Número màxim de convivents no nominals per zona i reserva. Aquesta opció s'aplica si l'usuari no disposa de convivents nominals",
  minutosApertura: "Activar obertura minuts abans de l'hora de reserva",
  mantenerApertura: "Mantenir obertura després de tancament minuts després",
  AperturaAutomatica: "Obertura automàtica de porta",
  unCuartoDeHora: "1 quart d'hora",
  mediaHora: "Mitja hora",
  tresCuartosHora: "3 quarts d'hora",
  unaHora: "1 hora",
  unaHoraYMedia: "1 Hora i Mitja",
  Horas: "Hores",
  HorasYMedia: "Hores i Mitja",
  HoraDeApertura: "Hora d'obertura",
  HoraDeCierre: "Hora de tancament",
  TamanoSlot: 'Grandària del "slot"',
  TodasComunidades: "Totes les comunitats",
  DireccionPrincipal: "Adreça principal",
  EstablecerHorarioFindes: "Establir horari per a caps de setmana i festius",
  CalendarioDiasFestivos: "Calendari de dies festius",
  DireccionRepetida: "La direcció ja està al sistema",
  FestivosSeleccionados: "Dies festius",
  Enero: "Gener",
  en: "gen",
  Febrero: "Febrer",
  feb: "feb",
  Marzo: "Març",
  mar: "mar",
  Abril: "Abril",
  abr: "abr",
  Mayo: "Maig",
  may: "mai",
  Junio: "Juny",
  jun: "jun",
  Julio: "Juliol",
  jul: "jul",
  Agosto: "Agost",
  ago: "ago",
  Septiembre: "Setembre",
  sep: "set",
  Octubre: "Octubre",
  oct: "oct",
  Noviembre: "Novembre",
  nov: "nov",
  Diciembre: "Desembre",
  dic: "des",
  Sabado: "Dissabte",
  sab: "dis",
  Domingo: "Diumenge",
  dom: "diu",
  Lunes: "Dilluns",
  lun: "dil",
  Martes: "Dimarts",
  mar: "dim",
  Miercoles: "Dimecres",
  mier: "dim",
  Jueves: "Dijous",
  jue: "dij",
  Viernes: "Divendres",
  vie: "div",
  AnadirHorario: "Afegir Horari",
  QuitarHorario: "Treure Horari",
  HoraApertura: "Hora d'Obertura",
  HoraCierre: "Hora de Tancament",
  Sabados: "Dissabtes",
  Domingos: "Diumenges",
  Festivos: "Festius",
  AnadirQuitarFestivos: "Afegir o Treure Dies Festius",
  Fecha_Publicacion: "Data de publicació",
  errorValidacionStock1:
    "Si utilitzes el control d'estoc de reserves, el valor del límit de reserves ha de ser almenys 1",
  errorValidacionStock2:
    "La data de l'inici o fi de la temporada de control d'estoc no pot ser buida",
  errorValidacionStock3:
    "La data de l'inici i fi de la temporada de control d'estoc no pot ser la mateixa",
  AnadirEmpleado: "Afegir Empleat",
  mensajeErrorHoras: "L'hora de tancament no pot ser anterior a l'hora d'Obertura",
  confirmarBorradoProveedor: "Estàs segur que vols esborrar el proveïdor?",
  tituloConfirmarProveedor: "Confirmar esborrat de proveïdor",
  UsuariosCongreso: "Usuaris CNAF2024",
  Contrasena: "Contrasenya",
  Abonos: "Taula d'Abonaments",
  AbonosLuz: "Taula d'Abonaments de llum",
  ContratosAsoaciados: "Contractes associats a l'activitat",
  SinContratos: "Sense contractes associats o el proveïdor ve de connecta",
  ConContratos: "Amb contractes associats",
  TipoCobroAbono: "Tipus Cobrament Abonament",
  TipoCobroAbonoLuz: "Tipus Cobrament Abonament de llum",
  Abonado: "Abonat",
  CodigoAbono: "Codi Abonament",
  StockActual: "Estoc Actual",
  Observaciones: "Observacions",
  ReservasDisponiblesPorAbono: "Reserves disponible per abonament",
  CosteEuros: "Cost en euros",
  TablaUsuariosAbono: "Taula Usuaris Abonament",
  TiposPagos: "Tipus de Pagament",
  RecargaAbonoApp: "Recàrrega d'abonament app",
  RecargaAbonoLuz: "Recàrrega d'abonament de llum",
  UsuariosAbonoLuz: "Usuaris abonament de llum",
  TiposPagosLuz: "Tipus de Pagament de Llum",
  HoraInicioLuz: "Hora inici llum",
  HoraFinLuz: "Hora fi llum",
  ABIERTO: "OBERT",
  BLOQUEADO: "BLOQUEJAT",
  NoBorrarActividadGremiosAsociados:
    "No es pot esborrar l'activitat perquè té proveïdors associats",
  NoBorrarActividadIncidenciasAsociadas:
    "No es pot esborrar l'activitat perquè té incidències associades",
  TodoCorrecto: "Tot correcte",
  ContratoActividadExpiracion: "El contracte de l'activitat està a punt d'expirar",
  DetectadoProveedorEliminadoDespacho:
    "Des de c365 hem detectat un proveïdor eliminat al seu despatx, aquest proveïdor ha estat eliminat de l'activitat en la qual estava associat, se li va a associar a l'administrador",
  ActividadIncidenciasAbiertas: "L'activitat té incidència/es obertes associades amb el codi : ",
  NoGremiosAsociados: "No hi ha proveïdors associats a l'activitat",
  CentroDeTrabajoCreadoAnteriormente: "Aquest centre de treball ja ha estat creat anteriorment",
  Completado: "Completat",
  UsuarioCreadoAnteriormente: "Aquest usuari ja ha estat creat anteriorment",
  AnchoYAltoImagen: "L'ample de la imatge ha de ser de 1054 píxels i l'altura de 444 píxels",
  NoDatosDisponibles: "No hi ha dades disponibles",
  ReservasZonasComunes: "Reserves zones comunes",
  GestionReservas: "Gestió de reserves",
  CodigoDebeSerNumero: "El codi ha de ser un número",
  ElCodigo: "El codi ",
  CoincideConOtraComunidad: " coincideix amb el d'una altra comunitat",
  VerContratos: "Veure contractes",
  ExisteEvaluacionNombreCambialo:
    "Ja existeix una avaluació amb aquest nom, si us plau canvia el nom per poder crear-la",
  PruebaActualizadaCorrectamente: "Prova actualitzada correctament",
  TituloEvaluacion: "Títol de l'avaluació",
  CampoObligatorio: "aquest camp és obligatori",
  FechaCreacion: "Data de creació",
  SeleccionAreasEvaluacion: "Selecciona les àrees que aplica l'avaluació",
  SeleccionPruebasEvaluacion: "Selecciona les proves per a aquesta avaluació",
  FechaInicio: "Data d'inici",
  FechaInicialEvaluacionAntesFinal:
    "La data inicial de l'avaluació ha de ser abans de la data final",
  FechaFinEvaluacion: "Data fi avaluació",
  CambiarNombreDe: "Canviar nom de ",
  AnadirNombreCarpetaFichero: "Afegeix el nom que vols posar al fitxer/carpeta",
  EnvioAvisoPrueba: "enviament avís prova",
  NombreDeUsuario: "Nom d'usuari",
  SinComunidadAsociada: "Sense comunitat associada",
  SinActividadAsociada: "Sense activitat associada",
  Contratos: "Contractes",
  AnadirContrato: "Afegir contracte",
  seleccionarComu2: "Ocult en totes les comunitats",
  DebesSeleccionarComunidadAnadirContrato:
    "Has de seleccionar una comunitat per afegir un contracte",
  DebesSeleccionarActividadAnadirContrato:
    "Has de seleccionar una activitat per afegir un contracte",
  DebesSeleccionarFechaInicioAnadirContrato:
    "Has de seleccionar una data d'inici per afegir un contracte",
  YaExisteContratoParaActividadEnComunidad:
    "Ja existeix un contracte per a aquesta activitat en aquesta comunitat",
  YaExisteContratoParaActividadEnComunidad2:
    "Ja existeix un contracte per a aquesta activitat en aquesta comunitat i en el proveïdor actual",
  ContratoAnadidoCorrectamente: "Contracte afegit correctament",
  ContratoEliminadoCorrectamente: "Contracte eliminat correctament",
  Indefinido: "Indefinit",
  VerIncidenciasDe: "Veure incidències de: ",
  DetalleProveedor: "Detall del proveïdor",
  ErrorBorrarArchivoCarpeta: "Error en esborrar l'arxiu/carpeta: ",
  DocumentacionDeLaIncidencia: "Documentació de la incidència",
  SinHorasRegistradas: "Sense hores registrades",
  DireccionRepetida: "La direcció està repetida",
  ValorEnterosNumerico: "El valor d'enters ha de ser numèric",
  NoDejarEnterosVacios: "No pots deixar els enters buits",
  NoDejarReservasVacias: "No pots deixar els drets de reserva buits",
  NoDejarDireccionVacia: "No pots deixar la direcció buida",
  RegistroRepresentanteCambiado: "Registre de representant canviat.",
  ImagenUsuario: "Imatge de l'usuari",
  ImagenPorDefecto: "Imatge per defecte",
  AnadirAlMenosUnaOpcionVotacion: "Has d'afegir almenys una opció de votació",
  NoAnadirOpcionRepetida: "No pots afegir una opció repetida",
  NoAnadirOpcionVacia: "No pots afegir una opció buida",
  MostrarVotacionesBorradas: "Mostrar votacions esborrades",
  OcultarVotacionesBorradas: "Ocultar votacions esborrades",
  VotacionCerrada: "Votació tancada",
  VotacionPublicada: "Votació Publicada",
  VotacionAbiertaPublicada: "Votació oberta i publicada.",
  VerLog: "Veure log",
  AnadirBono: "Afegir nou bo",
  TituloBajaAbono: "Esborrar abonament",
  ConfirmarBajaAbono: "Estàs segur que vols esborrar l'abonament?",
  TituloBajaTipoAbono: "Esborrar tipus d'abonament",
  TituloBajaTipoAbonoLuz: "Esborrar tipus d'abonament de llum",
  ConfirmarBajaTipoAbono: "Estàs segur que vols esborrar el tipus d'abonament?",
  ConfirmarBajaTipoAbonoLuz: "Estàs segur que vols esborrar el tipus d'abonament de llum?",
  ProblemaNoPodidoEnviar: `Hi ha hagut un problema i no s'ha pogut enviar`,
  AvisoEnviadoCorrectamenteA: "Avís enviat correctament a ",
  destinatarios: " destinataris",
  FalloEnviarAviso: "Error en enviar l'avís: ",
  SoloPuedesSubirUnArchivo: "Només pots pujar 1 arxiu",
  NoPuedesDejarTipoVacio: "No pots deixar el tipus buit",
  FalloEnElPago: `ERROR EN EL PAGAMENT`,
  ErrorAbrirNuevaVentanaPermisosVentanas:
    "Error en obrir la nova finestra, assegura't de tenir permisos per obrir finestres emergents.",
  ContratoAceptadoPagosIniciados: "Contracte Acceptat i pagaments iniciats.",
  ArrastraSueltaArchivosSubirlosCarpeta:
    "Arrossega i deixa anar aquí els teus arxius per pujar-los a la carpeta:",
  AnadirTipoBono: "Afegir tipus d'abonament",
  AnadirTipoBonoLuz: "Afegir tipus d'abonament de llum",
  AlertaGuardarCambios:
    "Has fet canvis a la taula, perquè els canvis es guardin fes clic a 'Guardar'.",
  ProveedorBajaEnComunidades: "El proveïdor ha estat donat de baixa a les comunitat/s",
  FInicio: "F. Inici",
  FFin: "F. Fi",
  Contratar: "Contractar",
  AceptarTerminosContratacion: "Acceptar termes de contractació",
  VolverPrimerPaso: "Tornar 1r Pas",
  DetalleComunidad: "Detall Comunitat",
  Juntas: "Juntes",
  MensajeRecargaAbonos:
    "Posa't en contacte amb suport per facilitar-nos les dades de la comunitat i l'IBAN per configurar la plataforma de cobrament",
  MensajeAperturaAutomatica:
    "Posa't en contacte amb suport per facilitar-nos les dades de la comunitat i l'IBAN per configurar la plataforma de cobrament per a la instal·lació d'obertura automàtica de la porta",
  Reservar: "Reservar zona",
  BloquearReservas: "Bloquejar Zona Comuna",
  seleccionaSlot: "Selecciona el/els slot/s",
  SeleccionaUsuario: "Selecciona un usuari",
  comunidadActiva: "Comunitat activa",
  comunidadInactiva: "Aquesta comunitat no està d'alta a C365",
  comunidadBloqueada: "Recorda que aquesta comunitat està bloquejada",
  NumeroJunta: "Nº de Junta",
  Titulo: "Títol",
  confirmarBorradoJunta: "Prem acceptar per esborrar la junta",
  AnadirJunta: "Afegir Junta",
  FechaCelebracion: "Data de celebració",
  tip_BorrarJunta: "Esborrar junta",
  NumeroAsistentes: "Número d'assistents",
  JuntasComunidad: "Juntes de la comunitat",
  AbrirConexion: "Obrir junta",
  CerrarConexion: "Tancar junta",
  Abierta: "Oberta",
  Cerrada: "Tancada",
  VideoComunidad: "Videoconferència de la comunitat",
  Entrar: "Entrar",
  Junta: "Junta",
  TextoAyudaActividades1:
    "Selecciona les activitats sobre les que vulguis que els veïns d'aquesta comunitat puguin enviar incidències.",
  TextoAyudaActividades2:
    "Només les icones de les activitats seleccionades apareixeran en el mòbil dels veïns d'aquesta comunitat.",
  TextoAyudaActividades3: "Els administradors rebran TOTES les incidències.",
  TextoAyudaActividades4:
    "Si vols que, a més de l'administrador, un proveïdor rebi les incidències d'una activitat, associa'l des del detall de l'activitat o del proveïdor.",
  JuntaCerradaPestanaCerrandose:
    "La videoconferència ha estat tancada, la pestanya actual es tancarà en 10 segons",
  HabilitarQR: "Habilitar QR",
  irAlEnlace: "Fes clic aquí per copiar l'enllaç",
  tip_BorrarUsuarioWeb: "Esborrar usuari creat des de la web",
  tip_BorrarUsuarioConecta: "No és possible esborrar un usuari importat des de la integració",
  cuerpoEliminarUsuario: "Vols eliminar l'usuari ",
  tituloEliminarUsuario: "Eliminar usuari ",
  ActivarUsuarioApp: "Activar la APP per a l'usuari",
  TextoActivarUsuarioApp:
    "Per activar l'usuari a la APP si us plau, escriu una contrasenya i prem acceptar.",
  EmailVerificado: "Email verificat",
  ErrorVerificacionEmail: "Error al verificar email",
  ErrorBajaUsuario: "Error al donar de baixa l'usuari",
  ProcesoActivacionCompleto: "Procés d'activació d'usuari completat",
  tituloBajaUsuarioAPP: "Desactivar l'usuari",
  textoBajaUsuarioAPP: "Prem acceptar per donar de baixa en la APP l'usuari",
  ProcesoDesactivacionCompleto: "Procés de desactivació d'usuari completat",
  tip_usuarioActivado:
    "Usuari amb accés a la APP. Prem si vols desactivar l'accés de l'usuari a la APP.",
  tip_usuarioDesactivado:
    "Usuari sense accés a la APP. Prem si vols activar l'accés de l'usuari a la APP.",
  tip_usuarioSinValidar: "Usuari registrat però no ha validat la seva compte d'email encara.",
  amarillo_faltanDatosUsuario:
    "Falta/n la/les dada/es [${var1}], si us plau, completa les dades dels usuaris d'aquesta comunitat en el teu ERP perquè CAFPortal pugui volcar-los en C365",
  amarillo_usuarioNoRegistrado: "Aquest usuari encara no està registrat a C365",
  amarillo_usuarioViviendaNoAsignada: "Aquest usuari no té habitatge assignat",
  amarillo_usuarioFalloFichaje:
    "Falta algun registre de sortida en els fitxatges dels dies: ${var1}",
  amarillo_usuarioCamposVacios:
    "Falten les dades :[${var1}], si us plau, completa les dades dels usuaris d'aquesta comunitat en el teu ERP perquè CAFPortal pugui volcar-los en C365",
  amarillo_usuarioNoValidado: "Aquest usuari no ha validat la seva compte d'email",
  rojo_usuarioBloqueado: "Recorda que aquest usuari està bloquejat",
  verde_usuarioCorrecto: "Usuari correcte",
  tip_publicarJunta: "Publicar/Despublicar la junta",
  confirmarPublicacionJunta: "Prem acceptar per publicar aquesta junta",
  tituloConfirmarPublicacion: "Publicar junta",
  confirmarDespublicacionJunta: "Prem acceptar per despublicar aquesta junta",
  tituloConfirmarDespublicacion: "Despublicar junta",
  JuntaPublicadaCorrectamente: "Junta publicada correctament",
  errorBorrarIncidencia: "Error en publicar la junta",
  errorAbrirJunta: "Error en obrir la connexió",
  Asistentes: "Assistents",
  asistentes: "assistents",
  activado: "activat",
  desactivado: "desactivat",
  Asistente: "Assistent",
  asistente: "assistent",
  ControlAsistenciaUsuarios: "Control d'assistència d'usuaris",
  Viviendas: "Habitatges",
  Vivienda: "Habitatge",
  Conexiones: "Nº Connexions",
  HoraEntrada: "Última entrada",
  HoraSalida: "Última sortida",
  TotalDuracion: "Durada total (minuts)",
  confirmarBorradoAsistente: "Estàs segur que vols esborrar l'assistent a la junta?",
  tituloConfirmarBorradoAsistente: "Confirmar esborrat d'assistent",
  RolBorradoCorrectamente: "Assistent esborrat correctament",
  tip_BorrarAsistente: "Prem per esborrar un assistent",
  TipoAsistencia: "Tipus d'Assistència",
  NoCentroNoFichar: "No pots fitxar si no tens un centre de treball assignat",
  asistirJunta: "Validar",
  CodigoCopiadoPortapapeles: "Codi copiat al porta-retalls",
  ProveedorLocalAnadido:
    "Des de C365 CAFPortal hem detectat un nou proveïdor en el seu despatx creat des del mòdul local. Pot comprovar si les dades són correctes i procedir a associar-lo a una activitat",
  tip_EnvioUsuarios: "Enviament avís als usuaris prèviament seleccionats",
  tip_EnvioCodVec: "Enviament email registre als usuaris prèviament seleccionats",
  NoSoyPropietario: "No sóc propietari",
  placeholderObservaciones: "Si us plau indica el motiu d'assistència a aquesta junta",
  ErrorGuardandoAsistencia: "Error guardant assistència",
  AsistenciaRegistradaConExito: "La teva assistència ha estat registrada correctament.",
  ReservaCompleta: "Reserva completa",
  EmpleadoComunidad: "Empleat de la comunitat",
  JuntaAsociada: "Junta Associada",
  ErrorFechasContrato: "La data d'inici no pot ser major que la data de fi",
  ErrorProveedorContrato: "El proveïdor no pot ser buit",
  ErrorFechaInicioMayor: "La data d'inici no pot ser major que la data de fi",
  SinJuntaAsociada: "Sense junta associada",
  EmailNoValidoIntroduceCorrecto: "El Email no és vàlid, introdueix-ne un de correcte",
  verde_UsuarioRegistrado: "Usuari registrat en C365",
  verde_UsuarioNoRegistrado: "Usuari no registrat en C365",
  ErrorEmailVacio: "Per registrar a l'usuari és necessari que l'usuari disposi d'un email",
  EmailNoValido: "El email no és vàlid",
  Conexion: "Connexió",
  InactivarProveedorConContratos:
    "No es pot desactivar un proveïdor amb contractes associats. Si us plau, elimina els contractes abans de desactivar el proveïdor",
  TiempoAcumulado: "Temps acumulat",
  QR: "Codi QR",
  MostrarQR: "Mostrar QR",
  FormularioAsistencia: "Formulari d'assistència a la junta",
  EnlaceQRNoDisponible: "Codi QR per al formulari d'assistència no habilitat.",
  verObservaciones: "Veure observacions",
  ocultarObservaciones: "Ocultar observacions",
  Enviar: "Enviar",
  tituloFormAvisosJuntas: "Enviar avís de la junta",
  Asociados: "Contractes actuals",
  AsociadosHistoricos: "Contractes històrics",
  BorrarActividadContrato: "Eliminar contracte",
  tituloConfirmarContrato: "Confirmar eliminació de contracte",
  confirmarBorradoContrato: "Estàs segur que vols esborrar el contracte?",
  ContratosHistoricos: "Contractes històrics",
  guardarEnPdf: "Descarregar QR",
  notiArchi: "Notificació arxivada correctament",
  SinUsuarios: "Sense usuaris associats al centre de treball",
  PlantillaConvocatoria: "Descarregar Convocatòria",
  PlantillaActa: "Descarregar Acta de Resolució",
  Convocatoria: "Convocatòria",
  Acta: "Acta",
  PrimeraConvocatoria: "Hora Primera Convocatòria",
  SegundaConvocatoria: "Hora Segona Convocatòria",
  LugarCelebracion: "Lloc de celebració",
  ORDINARIA: "Ordinària",
  EXTRAORDINARIA: "Extraordinària",
  ZonaBien: "Zona comuna correctament configurada",
  ZonaFestivosMal:
    "La zona comuna té marcat el checkbox d'horari en festius però no té cap horari configurat",
  ZonaHorariosBloqueados: "La zona comuna té horaris bloquejats",
  ordenDiaStandar1: "Aprovació, si procedeix, dels comptes anuals.",
  ordenDiaStandar2: "Aprovació, si procedeix, del pressupost ordinari de despeses i ingressos.",
  ordenDiaStandar3:
    "Relleu de càrrecs i nomenament de la nova Junta de Govern (President, Vicepresident, Vocals i Administrador)",
  ordenDiaStandar4: "Relleu de càrrecs en junta de govern",
  ordenDiaStandar5: "Precs i preguntes",
  ordenDiaStandar1Desc: "",
  ordenDiaStandar2Desc: "",
  Convocante: "Convocant",
  juntaCerradaPorApertura:
    "S'ha tancat la videoconferència prèviament oberta per permetre la nova connexió",
  ErrorJuntaNoPublicada: "No pots obrir la connexió si la junta no està publicada",
  Abrir: "Obrir",
  Descripcion: "Descripció",
  Junta: "Junta",
  Nombre: "Nom",
  Publicar: "Publicar",
  PublicarPorcentaje: "Publicar percentatge",
  PublicarResultado: "Publicar resultat",
  Roles: "Rols",
  Vacio: "Buit",
  Votode: "VOT DE",
  hasioeliminao: "HA ESTAT ELIMINAT",
  QRasistencia: "QR assistència",
  CheckboxVotaciones: "Ordre del dia / Votacions",
  TooltipVotaciones: "Incloure votacions associades a la convocatòria de la junta",
  LibresDe: "Lliures de",
  BLOQUEAEDA: "BLOQUEJADA",
  SalaCompleta: "Sala completa",
  BloquearDesbloquear: "Bloquejar/Desbloquejar tot el dia",
  TituloBorrarReserva: "Cancel·lar reserva",
  CuerpoBorrarReserva: "Estàs segur que vols cancel·lar la reserva?",
  camposCriticos:
    "L'administrador ha canviat dades crítiques de la zona comuna, s'ha recuperat l'estoc de ",
  camposCriticosSinAbono:
    "L'administrador ha canviat dades crítiques de la zona comuna, s'ha/han anul·lat la teva reserva/es: ",
  tituloCamposCriticos: "Recuperació d'estoc",
  tituloCamposCriticosSinAbono: "Anul·lació de reserva",
  AlertaNumPersonasAforo:
    "El nombre de persones permès per reserva no pot ser major que l'aforament permès de la Zona: ${var1}",
  labelLimitaciones2: "Hora d'aplicació",
  labelLimitaciones4: "Hores mínimes de diferència",
  labelLimitaciones5: "Hores fins a alliberament",
  seleccionaHoraLimitacion: "Selecciona hora",
  NoAsistido: "No ha assistit",
  AlertaSeCerraraConexion: "En despublicar la junta també es tancarà la connexió.",
  Anulacion: "S'ha anul·lat la reserva",
  haCanceladoReserva: "ha cancel·lat la reserva",
  ParaElDia: "Per al dia",
  para: "per",
  verDetalleEnvio: "Veure el detall de l'enviament",
  seHaReservado: "s'ha reservat",
  haReservado: "ha reservat",
  enNombreDe: "en nom de",
  reservaZonaComun: "Confirmació reserva",
  adminBloqueoReserva: "L'administrador ha bloquejat la reserva",
  delDia: "del dia",
  ContratoActividadExpirado: "El contracte de l'activitat ha expirat",
  SinContrato: "Sense contracte",
  rolEncontradoUsu: "El rol es pot esborrar perquè està assignat en usuaris en les comunitats",
  rolEncontradoVota: "El rol es pot esborrar perquè està assignat en votacions en les comunitats",
  enLasVotaciones: " i a les votacions",
  rolEncontradoJuntas: "El rol es pot esborrar perquè està assignat en juntes en les comunitats",
  enLasJuntas: " i a les juntes",
  ningunaDeLasPropuestas: "Cap opció de les propostes",
  resultadoEscrutinio: "Resultat de l'escrutini",
  Escrutinio1: "⅓ dels vots",
  Escrutinio2: "Majoria simple",
  Escrutinio3: "Majoria reforçada",
  Escrutinio4: "⅗ parts dels assistents",
  Escrutinio5: "Unanimitat",
  tooltipEscrutinio2: "Més de la meitat dels vots o més del 50% de la quota de participació",
  tooltipEscrutinio3:
    "⅗ parts. Es sumen els vots dels no assistents als vots de la majoria, i aquests tenen 1 mes per revocar el seu vot. No es pot generar l'acta fins que hagi passat el mes",
  NaturalezaVotacion: "Naturalesa de la votació",
  ResultadoVotacion: "Resultat de la votació",
  Aprobada: "Aprovada",
  NoAprobada: "No aprovada",
  ConclusionesVotacion: "Conclusions de la votació",
  Conclusiones: "Conclusions de la votació",
  configuracionCorrecta: "Configuració correcta",
  contratoActivo: "Contracte actiu",
  contratoCaducado: "Contracte caducat, al proveïdor li seguiran arribant avisos",
  Nombre: "Nom",
  Apellido: "Cognom",
  Email: "Email",
  DNI: "NIF/NIE/CIF",
  DNI2: "NIF/CIF",
  Telefono: "Telèfon",
  BuscarEnTodos: "Cercar en tots els camps",
  AnularReserva: "Cancel·lar",
  ErrorCancelarReserva: "No es pot cancel·lar una reserva cancel·lada / bloquejada",
  DetalleNotificacion: "Detall de la notificació",
  DocumentacionNotificacion: "Documentació Notificació",
  IrDetalleIncidencia: "Veure incidència relacionada",
  CuerpoBloqueoNotificacion:
    "En esborrar la notificació cap dels usuaris que l'han rebuda podrà accedir i visualitzar-la",
  TituloBloqueoNotificacion: "Confirmar esborrat de la notificació",
  Leida: "Llegida",
  FechaLectura: "Data de lectura",
  IdUsuario: "Id Usuari",
  DispositivosEnviados: "Dispositius enviats",
  DispositivosError: "Dispositius amb error",
  marcarNotificacionLeida: "Marcar o desmarcar la notificació com a llegida",
  archivarNotificacion: "Arxivar o desarxivar la notificació",
  desmarcarNotificacionLeida: 'Per desmarcar la notificació com a llegida prem "ACCEPTAR"',
  marcarNotificacionLeida: 'Per marcar la notificació com a llegida prem "ACCEPTAR"',
  tituloNotificacionLeida: "Marcar Notificació LLEGIDA/NO LLEGIDA",
  recuperarNotificacion: 'Per recuperar la notificació prem "ACCEPTAR"',
  archivarNotificacion: 'Per arxivar la notificació prem "ACCEPTAR"',
  tituloArchivarNotificaciones: "Arxivar notificacions",
  marcadaLeida: "Marcada o desmarcada com a llegida",
  marcadaArchivada: "Marcada o desmarcada com a arxivada",
  sinNombre: "Sense nom",
  sinApellido: "Sense cognoms",
  LEIDA: "LLEGIDA",
  NOLEIDA: "NO LLEGIDA",
  TostaNotificacionArchivada: "La notificació ha estat arxivada",
  TostaNotificacionDesarchivada: "La notificació ja no està arxivada",
  TostaNotificacionLeida: "La notificació ha estat marcada com a llegida",
  TostaNotificacionNoLeida: "La notificació ha estat marcada com a no llegida",
  TituloDispositivosUsuario: "Taula de dispositius de l'usuari ",
  conERROR: " amb ERROR",
  TextoNotificacion: "Text notificació",
  UrlAdjunta: "Url adjunta",
  envioDispositivoCorrecto: "L'avís ha estat enviat i rebut correctament en el dispositiu",
  envioDispositivoIncorrecto: "L'avís no ha pogut ser enviat i no ha estat rebut en el dispositiu",
  errorEnvioNoti:
    "No s'ha pogut enviar l'avís ni ha estat rebut en tots els possibles dispositius (",
  errorEnvioNoti1: "No s'ha pogut enviar l'avís ni ha estat rebut en ",
  errorEnvioNoti2: " dispositius de ",
  errorEnvioNoti3: " enviats",
  exitoEnvioDispositivos: "Tots els dispositius han rebut l'avís correctament",
  NavegarJunta: "Navegar a la junta",
  tip_asistirJunta: "Assistència",
  tituloAsistencia: "Detall de l'assistència",
  datosAsistencia: "Dades de l'assistència",
  //ASISTENCIA_REMOTA_APP: "REMOTA - APP",
  ASISTENCIA_REMOTA_APP_DELEGADO: "REMOTA - APP DELEGAT",
  ASISTENCIA_REMOTA: "REMOTA",
  ASISTENCIA_REMOTA_ENLACE_VIDEO: "REMOTA - ENLLAÇ VIDEO",
  ENLACE: "ENLLAÇ",
  APP: "APP",
  ASISTENCIA_FISICA_QR: "FÍSICA QR",
  ASISTENCIA_FISICA_FORMULARIO: "FÍSICA FORMULARI",
  ASISTENCIA_FISICA_FORMULARIO_NO_PROPIETARIO: "FÍSICA FORMULARI + NO PROPIETARI",
  ASISTENCIA_FISICA: "FÍSICA",
  ASISTENCIA_DELEGADA: "DELEGADA",
  ASISTENCIA_: `\u00A0`,
  rojo_usuarioDesactivado: "Aquest usuari encara no està registrat a C365",
  ErrorRecuperandoDatosAsistente: "Error mentre es recuperaven les dades de l'assistent",
  DelegadoEn: "Delegat a",
  usuarioHaVotado: "L'usuari ha votat",
  NuevoAsistente: "Nou assistent",
  NoEstasRegistradoAPP: "No estàs registrat a l'APP",
  usuarioSinVotar: "L'usuari ha assistit però no ha votat",
  ErrorSeleccionOpcionVotacion:
    "Has seleccionat la naturalesa de la votació unanimitat però no has seleccionat cap opció",
  ErrorSeleccionResultadoVotacion:
    "Has seleccionat la naturalesa de la votació unanimitat però no has seleccionat cap resultat",
  Abs: "Abs",
  JuntaSinConexion: "Reunió sense junta",
  AutoRellenarDNI:
    "Introdueix el teu DNI per auto-omplir les teves dades si estàs a la base de dades de la comunitat",
  UsuarioNoRegistradoEnApp:
    "T'hem trobat a la base de dades de la comunitat, però no estàs registrat a l'APP. Vols que t'enviem un email amb els passos necessaris perquè puguis donar-te d'alta?",
  TipoVotacion: "Tipus de votació",
  QuitarAsistencia:
    "Estàs a punt de treure l'assistència a la junta, s'esborraran tots els vots de l'usuari associats a la junta",
  VerFichajes: "Veure Fitxatges",
  PRESIDENTE: "President",
  FIRMANTES: "Els sotasignants",
  SeleccionaConvocante: "Selecciona convocant",
  PrimC: "1ª conv.",
  SegC: "2ª conv.",
  TipoJunta: "Tipus d'assistència",
  TituloConexion: "Títol de la connexió",
  AbrirEnlacePestanaNueva: "Obrir enllaç en una altra pestanya",
  Paso: "Pas",
  OcultarTutorial: "Ocultar tutorial",
  VerTutorial: "Veure tutorial",
  Destinatarios: "Destinataris",
  Crear: "Crear",
  AQuienVaDirigida: "A qui va dirigida?",
  CuandoYDonde: "Quan i on?",
  TipRolesJuntas: "(Per defecte tots els propietaris, selecciona un o diversos rols)",
  Servicios: "Serveis",
  ProcesoAltaComunidad: "Procés d'alta de Comunitat",
  ListaContratos: "Llista de contractes",
  IrADocumentacion: "Anar a la documentació de la junta",
  EstadoActual: "Estat actual",
  Publicada: "Publicada",
  NoPublicada: "Sense publicar",
  NoPublicar: "Despublicar",
  AsistentesConvocados: "Assistents convocats",
  AsistentesConfirmados: "Assistents confirmats",
  GenerarQR: "Generar QR",
  QRdeLaJunta: "Codi QR de la Junta",
  TipoConexion: "Tipus de connexió",
  DeshabilitarControlAsistencia: "Deshabilitar Control d'Assistència",
  HabilitarControlAsistencia: "Habilitar Control d'Assistència",
  Habilitado: "Habilitat",
  Deshabilitado: "Deshabilitat",
  TituloVotacion: "Títol de la votació",
  EsParaJunta: "És per a una Junta?",
  TipJuntasVotaciones: "Si és per a una junta selecciona una de la llista",
  TipoVotacion: "Tipus de votació",
  OpcionesVotacion: "Opcions de votació",
  NingunaDeLasOpciones: "Cap de les opcions",
  CriteriosVotacion: "Opció majoritària",
  AbrirVotacion: "Obrir votació",
  CerrarVotacion: "Tancar votació",
  VotacionAbierta: "Votació oberta",
  VotacionCerrada: "Votació tancada",
  NoPublicarResultado: "Despublicar resultat",
  PublicarResultado: "Publicar resultat",
  ResultadoNoPublicado: "Resultat no publicat",
  NoPublicarPorcentaje: "No mostrar percentatge",
  PublicarPorcentaje: "Mostrar percentatge",
  PorcentajeNoPublicado: "Mostrant percentatge",
  PorcentajePublicado: "No mostrant percentatge ",
  Votos: "Vots",
  totalVotosActa: "Total vots : ",
  sumaTotalHoras: "Suma total d'hores",
  QRfichar: "QR per fitxar",
  enPrep: "en",
  contratoanadir: "Afegir contracte",
  contratoanadira: "Afegir contracte a ",
  OcultarContratosCaducados: "Ocultar contractes finalitzats",
  MostrarContratosCaducados: "Mostrar contractes finalitzats",
  tituloEnvioAvisoVotacion: "Comunicat sobre votació",
  ContratoHisotrico: "Contracte històric",
  RegistroDeContratros: "Registre de contractes",
  OcultarIconosApp: "Visualització de funcionalitats a l'app del mòbil per a aquesta comunitat",
  VerJuntas: "Veure Juntes",
  Seguro: "Segur",
  Energia: "Energia",
  Mantenimiento: "Manteniment",
  Reformas: "Reformes",
  VerFacturas: "Veure factures",
  VerTutorial: "Veure tutorial",
  RegistroIncidencias: "Registre d'incidència",
  Compartida: "Compartida",
  SinCompartir: "Sense compartir",
  DocumentacionDeLaIncidenciaInfo:
    "Pujar, descarregar o visualitzar la documentació de la incidència",
  BotonSOS: "Botó SOS",
  NoPublicarIncidencia: "No es pot compartir una incidència no publicada, tancada o cancel·lada",
  RegistradoPor: "Registrat per",
  NoEliminarOpcionNinguna: "Ha d'haver com a mínim una opció de votació",
  ActividadesTitle: "Activitats",
  CiaSegurosComunidad: "Cia d'assegurances de la comunitat",
  ListadoDeActividades: "Llistat d'activitats",
  DetalleComunidad: "Detall de la comunitat",
  OcultoAPP: "Ocult en la APP",
  VisibleAPP: "Visible en la APP",
  ZonasComunes2: "Reserves",
  PermisosDeAcceso: "Permisos d'accés",
  NIFNIE: "NIF / NIE / CIF",
  DocumentacionInfo: "Descarregar o visualitzar la documentació de la comunitat",
  CentrosTrabajoNavegar: "Navegar als centres de treball",
  anadirDirecciones: "Afegir direccions",
  anadirDireccion: "Afegir direcció",
  funcionesNoDisponibles:
    "* Algunes funcionalitats no estaran disponibles perquè l'usuari no s'ha registrat en la app",
  solicitarConfirmacionEmail: "Sol·licitar Confirmació Compte email",
  restablecerContrasena: "Restablir contrasenya",
  seleccionaTipo: "Selecciona el tipus",
  UsuarioNoCreado: "L'usuari no ha estat creat, si us plau, intenta-ho de nou",
  cambiarContrasenaUser: "Canviar contrasenya d'usuari",
  VerificarEmail: "Verificar email",
  EliminarUser: "Eliminar usuari",
  verRegistroHorario: "Veure registre horari",
  verFichajesUsuario: "Veure els fitxatges d'usuari",
  EstadoActual: "Estat actual",
  CentrosAsignadosDetalle: "Centres de treball assignats",
  planContratadoActivo: "Pla contractat actiu:",
  actualizarModificarPack: "Actualitzar / Modificar pack",
  darDeBaja: "Donar de baixa",
  descargarPrecios: "Descarregar preus",
  Plan: "Pla",
  iban: "IBAN",
  numeroIban: "Número de IBAN",
  Vecinos: "Veïns",
  Periodicidad: "Periodicitat",
  Precio: "Preu",
  ViviendasEnComunidad: "Habitatges en la comunitat",
  EmailVerificado: "Email verificat",
  envioConfirmacionEmail: "Enviament de correu de confirmació",
  AvisosP: "Enviar notificació / email a l'usuari.",
  FicharDesactivado: "Fitxar desactivat",
  AsociarUsuariosCentroTrabajo: "Associar usuaris al centre de treball",
  IncidenciasRecibiraUsuario: "De quines comunitats rebrà incidències aquest usuari administrador",
  AsignalRolPorComunidad: "Assignar rol per comunitat",
  DocumentacionInfoUsers: "Enviar documentació confidencial als usuaris",
  otorgarPermisosUsuarios: "Atorgar permisos als usuaris",
  RecibirAverias: "Rebre avaries",
  // peticion del inmortal
  TipoDeConvocatoria: "Tipus de Junta",
  votoDelegado: "Vot delegat",
  Leida: "Llegida",
  SinLeer: "Sense llegir",
  ErrorSegundaConvocatoria: "La segona convocatòria no pot ser anterior a la primera",
  Archivada: "Arxivada",
  SinArchivar: "Sense arxivar",
  TelefonoNoValido: "El format del telèfon no és vàlid, si us plau introdueix-ne un de correcte.",
  ViviendasSolicitadasEnComunidad: "Habitatge sol·licitat en el registre en la APP",
  usuarioSinInstancia: "L'usuari s'ha registrat des de l'app però no té instància associada",
  adjudicarInstancia: "Adjudicar instància a l'usuari",
  rechazarAdjudicacion: "Rebutjar adjudicació d'instància",
  adjudicacionRechazadaExito: "Sol·licitud rebutjada",
  adjudicacionRechazadaFallo: "Error al rebutjar la sol·licitud",
  confirmarRechazarAdjudicacion: "Vols rebutjar la sol·licitud d'adjudicació d'instància?",
  viviendaSolicitada: "Sol·licitada en registre APP",
  ResultadoEnviosNotificaciones: "Resultat dels enviaments de notificacions",
  usuarioNoEncontradoEnComunidad:
    "Usuari no trobat en la base de dades de la comunitat, si no ets propietari marca el check de no sóc propietari",
  JuntaYaBorrada: "La junta ja ha estat esborrada",
  VisualizarAPP: "Veure Icones",
  VerIconosAPP: "Veure / Ocultar les icones en la APP",
  VisualizarAPPIconos: "Visualització de funcionalitats en l'app del mòbil per a aquesta comunitat",
  JuntaYaBorradaQR: "La junta ja ha estat esborrada, no es pot generar el QR",
  JuntaYaBorradaPublicar: "La junta ja ha estat esborrada, no es pot publicar",
  ConfigurarProveedores:
    "Completa les dades dels teus proveïdors contractats, per gestionar avaries i sinistres.",
  CrearCentrosTrabajo:
    "Habilita als empleats perquè puguin fitxar (si tens contractat el Pack Control Horari).",
  ConfigurarProveedores2: "Configuració proveïdors",
  MarcarActividades2: "Marcar activitats",
  AsociarProveedorAactividad: "Associar proveïdor a activitat",
  SubirDocumentos: "Pujar documents",
  CrearJuntasYvotaciones: "Crear juntes i votacions",
  AnadirZonasComunes: "Afegir zones comunes",
  CrearCentrosDeTrabajo: "Crear centres de treball",
  RegistroDeUsuarios: "Registre d'usuaris",
  CrearZonas: "Crear zones comunes",
  MostrarEnlace: "Mostrar enllaç",
  OcultarEnlace: "Ocultar enllaç",
  CrearJuntas: "Crear juntes",
  CrearVotaciones: "Crear votacions",
  AnadirZonasComunes2: "Crear centres de treball ",
  Totales: "Totals",
  VotoGuardadoCorrectamente: "Vot guardat correctament",
  AnadirVotoModificar: "Afegir / Modificar vot",
  SeleccionaUsuarioVotar: "Selecciona un usuari per votar",
  SeleccionaOpcionVotar: "Selecciona una opció per votar",
  ErrorAdjudicandoInstancia: "Ha passat un error adjudicant la instància.",
  CodigoAdministracionEnUso: "El codi d'administració ja està en ús",
  CodigoAdminitradorNoValido:
    "El valor ha de contenir exactament tres lletres seguides per un número.",
  usuarioConInstanciaSinAdjudicar: "L'usuari té una instància sense adjudicar",
  BloquearZona: "Bloquejar zona",
  errorBorrarIncidencia2: "Només es poden eliminar incidències amb l'estat TANCADA o CANCEL·LADA",
  ReservaCanceladaCorrectamente: "La reserva s'ha cancel·lat correctament",
  Contacto: "Contacte",
  enviadoscorrectosCabecera: "Notificacions enviades correctament",
  enviadosIncorrectosCabecera: "Notificacions enviades amb error",
  enviadosTotalesCabecera: "Notificacions enviades",
  enviadoTotalesCabeceraTexto: "Total de notificacions enviades",
  Calle: "Carrer",
  ReferenciaExt: "Referència",
  CNAEDescripcion: "Descripció CNAE",
  DatosContratoGuardadosCorrectamente: "Dades del contracte guardades correctament",
  Propiedades: "Propietats",
  PropietariosVecinos: "Propietaris/Llogaters/Empreses/Rep. Legals",
  DestinatarioConsulta: "Destinatari de la consulta",
  SlotReservadoDesbloquealo:
    "L'slot està bloquejat. Si vols reservar-lo primer has de desbloquejar-lo.",
  CreadoDesde: "Creat des de",
  ProveedorRecibiraEmail: "* El proveïdor rep sempre un correu amb els canvis en la incidència",
  EnviarNotificaciones: "Enviar notificacions",
  enviarEmails: "Enviar emails",
  ResetearBusqueda: "Resetejar cerca",
  Recibos: "Rebuts",
  RecibosDetalle: "Visualitzar rebuts",
  pagador: "Pagador",
  cobrador: "Cobrador",
  nif_cobrador: "NIF Cobrador",
  nif_pagador: "NIF Pagador",
  importe: "Import",
  fechaVencimiento: "Data de venciment",
  comentario: "Comentari",
  totalEnterosActa: "Total enters : ",
  Pagado: "Pagat",
  pdtPago: "Pendent de pagament",
  totalPagado: "Total pagat",
  RegistroDeAccesos: "Registre d'Accessos",
  AbrirConexionReunion: "Connexió de reunió",
  ErrorJuntaBorrada: "No pots obrir la connexió si la junta ja ha estat esborrada",
  tooltip_emulador: "Simulació només visual per als veïns de la comunitat",
  emulador: "Visualització APP per als veïns",
  GenerarQR: "Generar QR",
  RegistroHorarioDe: "Registre horari de l'usuari :",
  Mes: "Mes:",
  Semana: "Setmana:",
  ArrastrarImagen: "Arrossega o deixa anar aquí la imatge",
  SeleccionaOpcion: "Selecciona una opció",
  MostrarArchivadas: "Mostrar arxivades",
  FiltrarUsuariosAvisos: "Filtrar usuaris per a l'enviament d'avisos",
  ContratoActual: "Contracte actual",
  ListaContratosHistoricos: "Llista de contractes històrics",
  ResolucionNecesaria: "* Resolució necessària 1054px 444px",
  QueIncidenciasRecibira: "Quines incidències rebrà aquest usuari administrador?",
  seleccionaPlanNecesidades: "Selecciona el pla que més s'ajusti a les teves necessitats",
  Precios: "Preus",
  PackContratadoActual: "Pack contractat actual",
  SeleccionaFormaPago: "Selecciona la forma de pagament",
  PagoMensual: "Pagament Mensual",
  HasSeleccionadoPlan: "Has seleccionat el pla",
  ConFormaPago: "amb la forma de pagament",
  PagoAnual: "Pagament Anual",
  ElPRecioTotal: "El preu total és de",
  al: "al",
  Siguiente: "Següent",
  SeleccionaOpcionFacturacion: "Selecciona una opció de facturació",
  IBANComunidad: "IBAN de la Comunitat",
  IBANAdministrador: "IBAN de l'Administrador",
  conLa: "amb la",
  IBANElegido: "i l'IBAN triat és",
  cuentaBancariaEs: "i el compte bancari és",
  ResumenServicios: "Resum de Serveis Contractats",
  DetalleServicios: "A continuació, es detalla un resum dels serveis contractats",
  PlanSeleccionado: "Pla seleccionat",
  IbanAsociado: "IBAN associat",
  PrecioTotal: "Preu total",
  SiDeseasModificar:
    "Si vols realitzar modificacions, pots retrocedir en el procés de contractació i tornar al pas corresponent.",
  Atentamente: "Atentament",
  Empresa: "C365",
  PasoFinal: "Pas final",
  ResumenDeLosDatosContratados: "Resum de les dades contractades",
  DescargarContrato: "Descarregar contracte",
  DireccionCompleta: "Adreça Completa",
  AlertaTitulo: "¡ALERTA! Canvis en la naturalesa de la votació importants",
  Mensaje1: "En seleccionar la naturalesa de la votació",
  Mensaje2: "i l'opció",
  Mensaje3: "Se li assignarà el vot",
  Mensaje4: "a tots els votants en el moment de",
  ResultadoEnvio: "Resultat enviament",
  TokenDispositivo: "Token del dispositiu",
  ErrorTipo: "Error tipus",
  DetalleMensajeError: "Detall missatge error",
  PrimeraVezPago: "És la primera vegada que realitzes un pagament a càrrec del",
  ConEstaCuenta: "amb aquest compte: ",
  PulsaConfirmarPago: "Prem confirmar per carregar el pagament a aquesta compra i les següents.",
  ConfirmarIban: "Confirmar l'IBAN :",
  Confirmar: "Confirmar",
  Volver: "Tornar",
  VolverPrimerPaso: "Tornar 1r pas",
  MostrarVotosBorradas: "Mostrar vots esborrats",
  OcultarVotosBorradas: "Ocultar vots esborrats",
  ElAdminHaBorradoVotacion: "L'administrador ha esborrat la votació",
  NoBorrarActividadConContratos: "No es pot esborrar una activitat amb contractes associats",
  HazClicAquiParaAcceder: "Fes clic aquí per accedir",
  CifRepetido: "El CIF ja està en ús en un altre proveïdor",
  SuperAdministrador: "Super Administrador",
  DeshacerCambios: "Desfer canvis",
  Entendido: "Entès",
  comunidadIbanDiferente: "L'IBAN actual difereix del que figura en el contracte vigent.",
  NoTienesAcceso: "No tens accés a aquesta funcionalitat, redirigint a la pàgina principal",
  MostrarDatosAdminToast: "Es mostraran les dades del despatx de l'administrador",
  NoMostrarDatosAdminToast: "No es mostraran les dades del despatx de l'administrador",
  MostrarDatosDespacho: "Mostrar dades del despatx",
  MostrarRecibosComunidades: "Mostrar futurs rebuts de la comunitat",
  MarcarFuturosRecibosComunidad: "Marcar futurs rebuts de la comunitat",
  MarcarFuturosRecibosUsuarios: "Marcar futurs rebuts dels usuaris",
  Mostrar: "Mostrar",
  NoMostrar: "No mostrar",
  RecibosComunidad: "Rebuts de la comunitat",
  RecibosUsuarios: "Rebuts dels usuaris",
  VerEnLaAPP: "Veure en la APP",
  PublicarFuturosRecibos: "Publicar futurs rebuts",
  Publicados: "Publicats",
  SinPublicar: "Sense publicar",
  usuarioVotoBorrado: "El vot està esborrat",
  ContratoGuardadoCorrectamente: "Contracte guardat correctament",
  ArchivoBorradoCorrectamente: "Arxiu esborrat correctament",
  yaExisteEnOtroDespacho:
    "La comunitat ja existeix i està d'alta en un altre despatx, per poder continuar s'haurà de donar de baixa prèviament en l'altre despatx.",
  FechaUltimoAcesso: "Data últim accés",
  rojo_usuarioBloqueado: "Aquest usuari està bloquejat",
  ReferenciaExterna: "Referència externa",
  titloCambiarEstadoVotacion: "Canviar estat de la votació de ",
  estasSeguroCambiarEstado: "Estàs segur de voler canviar l'estat de la votació?",
  VotacionEstadoModificado: "L'estat de la votació ha estat modificat correctament",
  FechaUltimoAcceso: "Data últim accés",
  ReservasNoValidas: "El dret de reserva no és vàlid, ha de ser 0 o 1",
  pendienteValidarEmail: "Aquest usuari ja s'ha registrat, està pendent de validar el seu email.",
  ErrorUsuarioNoCreado: "No pots bloquejar / desbloquejar a un usuari que no està donat d'alta",
  EmailRequerido: "L'email és requerit per verificar el correu",
  todosCentroDeTrabajoSeleccionados:
    "Tots els usuaris del centre de treball han estat seleccionats",
  LimpiarBusqueda: "Netejar cerca",
  limpiarSeleccionados: "Netejar seleccionat",
  seleccionarTodos: "Seleccionar tots",
  seleccionarTodosFiltrado: "Seleccionar tots (filtrat)",
  todasLasComunidadesHanSidoSeleccionadas: "Totes les comunitats han estat seleccionades",
  noHayCentroDeTrabajo: "No hi ha centres de treball",
  centrosDeTrabajo: "Centres de treball",
  noHayComunidades: "No hi ha comunitats",
  todasComunidadesPorDefecto: "Totes comunitats per defecte",
  todosLosRolesHanSidoSeleccionados: "Tots els rols han estat seleccionats",
  noHayRoles: "No hi ha rols",
  seleccionarRoles: "Seleccionar rols",
  EmailIntegracion: "Email integració",
  AltaCorrectaDemo: "Alta correcta en la demo",
  CodigoIncorrectoDemo: "El codi d'introduït no és correcte",
  IntroduceCodigoGratiws: "Introdueix el codi per donar l'alta en C365",
  avisoBajaVecinosTitulo: "AVÍS DE BAIXA",
  avisoBajaAdministradorTitulo: "AVÍS DE BAIXA",
  avisoBajaVecinos:
    "El teu administrador ha donat de baixa l'app c365 de la teva comunitat, a partir d'aquest moment només podràs visualitzar en l'app les notificacions, fins que la teva comunitat reactivi els serveis.",
  avisoBajaAdministrador:
    "Hem rebut la sol·licitud de baixa de la plataforma c365, a partir d'aquest moment queda inactiva en la plataforma",
  conservarDatos1:
    "Aquesta comunitat ja va estar d'alta en c365, vols recuperar totes les dades d'aquesta comunitat?",
  conservarDatos2:
    "Si no conserves la configuració anterior, tingues en compte que tots els usuaris hauran de registrar-se en l'app de nou. Si tot i així, no vols conservar les dades prem “No Conservar”, en cas contrari “Conservar Dades”",
  ValidadoEnOtraComu: "L'usuari està validat però NO està d'alta en aquesta comunitat",
  idErp: "Id. Erp",
  tokenTitulo: "La sessió està a punt de caducar",
  tokenCuerpo: "Vols renovar la sessió?",
  ErrorVerificandoEmail: "Error verificant l'email",
  ordenActualizado: "Ordre actualitzat correctament",
  detectedComu:
    "Aquesta comunitat ja va estar d'alta en c365, vols recuperar totes les dades d'aquesta comunitat?",
  RecoverOldData: "Recuperar totes les dades",
  VisualizarAPPIconosDespacho:
    "Visualització funcionalitats en l'app del mòbil per a totes les comunitats",
  Sos: "SOS",
  Seguros: "Assegurances",
  todoVisible: "Visible en totes les comunitats",
  DNIYaExisteEnLaComu: "El DNI ja existeix en aquest despatx, si us plau, introdueix-ne un altre",
  ArrastrarSoltarImagen: "Arrossega o deixa anar aquí la imatge",
  altaOtroDesk: "L'usuari ja està d'alta en el despatx",
  enLasComus: " i en les comunitats: ",
  RedimensionarImagen: "La imatge s'ha redimensionat correctament a 1054px x 444px",
  comunidadFalta: "Falta el camp : ",
  comunidadFaltaImportante: "Falta l'assignació de ",
  comunidadFaltaImportante2: " omple-ho en activitats",
  DNIotracomunidad: "Hem detectat un usuari amb el mateix DNI en una altra comunitat",
  anadirloComunidad: "Vols afegir-lo a aquesta comunitat?",
  votacionBorrada2: "No pots modificar una votació esborrada",
  Responsable: "Responsable",
  SeleccionaResponsable: "Selecciona un responsable",
  ApellidoResponsable: "Cognom responsable",
  SuscripcionDespacho: "Llicència CAFcomunidad",
  DetallesLicencia: "Veure / desactivar llicència",
  procesoActivacionComunidad: "Procés d'activació de la comunitat",
  ResumenDeLaContratacion: "Resum de la contractació",
  DespachoSinIBAN:
    "Aquest despatx no té un IBAN associat, per corregir aquest problema tanca aquesta pestanya, afegeix l'IBAN al despatx en CAFportal i entra de nou en CAFcomunidad",
  ConfirmaDatosYAceptaContinuar: "Confirma les dades i accepta les condicions per continuar",
  ContratarActivar: "En contractar CAFComunidad per al despatx activaràs una",
  SuscripcionMensualDe: "subscripció mensual de",
  RecibosIBANDespacho: "Els rebuts es passaran a l'IBAN del despatx",
  DespachoSinIBAN:
    "Aquest despatx no té IBAN i el procés de contractació no pot ser completat. Si us plau afegeix-lo des de CAFportal.",
  DespachoNoActivado: "El teu despatx encara no ha estat activat en CAFcomunidad!",
  ActivarSuscripcionParaUsar:
    "Per poder usar CafComunidad primer hauràs d'activar la subscripció. Mentrestant podràs provar l'aplicació amb la comunitat de proves que tens disponible.",
  ContratarCAFComunidad: "Contractar CAFcomunidad",
  ContratarCafComunidadEsteDespacho: "Contractar CAFcomunidad per a aquest despatx",
  ErrorAbrirNuevaVentana:
    "Error en obrir la nova finestra, assegura't de tenir permisos per obrir finestres emergents.",
  ComunidadActivadaCorrectamente: "La comunitat ha estat activada correctament",
  DeseasActivarComunidad: "Vols Activar la comunitat?",
  DeseasIniciarPagosComunidad: "Vols Iniciar Pagaments de la comunitat?",
  PrecioComunidad: "El preu de la comunitat",
  Con: "amb",
  VecinosEsDe: "veïns és de",
  AlMes: "al mes",
  NumeroCuentaBancaria: "El número del compte bancari és",
  ComunidadNoIBAN:
    "La comunitat no disposa d'un IBAN, si us plau, accedeix a CAF portal i afegeix-lo",
  CambiarIdioma: "Canviar Idioma",
  ConfirmarCambiarIdioma:
    "Si canvies l'idioma pots perdre els canvis en els quals estaves treballant",
  agendarImportacionTitulo: "Programar importació de dades",
  agendarImportacionDescripcion: "Clica aquí per concertar cita per importar les teves dades",
  //Ultima revision 04-09
};
/*
export const diccionario_es_cosas= new Proxy(diccionario_es_base, {
  get(target, prop) {
    // If prop is a Symbol (like Symbol.toStringTag), return the default behavior
    if (typeof prop === "symbol") {
      return Reflect.get(target, prop);
    }
    // Otherwise, return the translated value or the fallback
    return prop in target ? target[prop] : `${String(prop)} [sin trad.]`;
  },
});
*/
export const tableLocation_cat = {
  pagination: {
    labelRowsSelect: "Files per pàgina",
    labelDisplayedRows: "{from}-{to} de {count}",
    firstAriaLabel: "Primera pàgina",
    firstTooltip: "Primera pàgina",
    previousAriaLabel: "Pàgina anterior",
    previousTooltip: "Pàgina anterior",
    nextAriaLabel: "Següent pàgina",
    nextTooltip: "Següent pàgina",
    lastAriaLabel: "Última pàgina",
    lastTooltip: "Última pàgina",
  },
  toolbar: {
    searchTooltip: "Cerca",
    searchPlaceholder: "Cerca",
    nRowsSelected: "{0} files(s) seleccionada(s)",
  },
  header: {
    actions: "Accions",
  },
  body: {
    emptyDataSourceMessage: "No hi ha dades disponibles",
    filterRow: {
      filterTooltip: "Filtrar",
    },
    editRow: {
      saveTooltip: "Desa",
      cancelTooltip: "Cancel·la",
      deleteText: "Segur que voleu suprimir aquesta fila?",
    },
    addTooltip: "Afegir fila",
    deleteTooltip: "Esborrar fila",
  },
  edit: {
    saveTooltip: "Desa",
    cancelTooltip: "Cancel·la",
    deleteText: "Segur que voleu suprimir aquesta fila?",
  },
  group: {
    deleteTooltip: "Esborrar grup",
    editTooltip: "Editar grup",
    addTooltip: "Afegir grup",
  },
};
